import { Injectable } from '@angular/core';
import { BehaviorSubject,Subject } from 'rxjs';
import { FacadeService } from './facade.service';

@Injectable({
  providedIn: 'root'
})
export class ProyectosService {
  private readonly summaryHighlightClass = 'summary-highlight-view';
  private readonly pilotMirrorActiveClass = 'text-area-shell--mirror-active';
  private readonly pilotMirrorEditingClass = 'text-area-shell--mirror-editing';
  private readonly regexLookbehindSupported = this.supportsRegexLookbehind();
  private highlightObserver: MutationObserver | null = null;
  private highlightSyncScheduled = false;
  private pilotMirrorActive = false;
  private pilotMirrorPayload: {
    html: string;
    mode: 'default' | 'summary';
    editable: boolean;
  } | null = null;
  private pilotMirrorOriginalText = '';
  private pilotMirrorInputHandler: (() => void) | null = null;
  private pilotMirrorFocusHandler: (() => void) | null = null;
  private lastTextareaMirrorMetrics: {
    fieldWidth: number;
    fieldHeight: number;
    textWidth: number;
    textHeight: number;
    paddingTop: number;
    paddingRight: number;
    paddingBottom: number;
    paddingLeft: number;
    marginBottom: string;
    font: string;
    fontFamily: string;
    fontSize: string;
    fontWeight: string;
    lineHeight: string;
    letterSpacing: string;
    wordSpacing: string;
    textTransform: string;
    textIndent: string;
    tabSize: string;
  } | null = null;
  public proyecto = { 
    id_project:'',
    user:{},
    name:'',
    config_json:{
      "delimiter": "%23",
      "split": "1",
      "textmode": "Writing",
      "englishType": "british",
      "targetCEFR": "A1",
      "matchPrhases": false
    },
    text:'Welcome to Text Inspector! To start, please replace this text here with the text you wish to inspect. You can either copy and paste your text here or import your text from a .txt or .doc file.\n \nAs you add text here, result will be shown on the right. ➔' ,
    texto_modificado:'',
    text_UID:'',
    sections:'',
    creation: "2024-10-08T09:27:22.792149Z",
    wordlist: null,
    update:null
  }

  public firstProject: boolean = false;

  private messageValue = new BehaviorSubject<boolean>(false);
  valueM$ = this.messageValue.asObservable();

  private valueCopy = new BehaviorSubject<boolean>(true);
  valueCopyButton$ = this.valueCopy.asObservable();
  

  private proyectoGuardadoSubject = new BehaviorSubject<void>(null);
  public proyectoGuardado$ = this.proyectoGuardadoSubject.asObservable();

  private blurHandler!: () => void;
  private tuvoFocus = false;

  private setHighlightDisplayMode(mode: 'default' | 'summary' = 'default'): void {
    const highlightedContent = document.getElementById('highlighted-content');
    const highlightedContentSpecific = document.getElementById('highlighted-content-specific');
    const highlightedContentMirror = document.getElementById('highlighted-content-mirror');

    if (!highlightedContent || !highlightedContentSpecific || !highlightedContentMirror) {
      return;
    }

    this.captureTextareaMirrorMetrics();
    highlightedContent.classList.toggle(this.summaryHighlightClass, mode === 'summary');
    highlightedContentSpecific.classList.remove(this.summaryHighlightClass);
    highlightedContentMirror.classList.toggle(this.summaryHighlightClass, mode === 'summary');
    this.scheduleHighlightSync();
  }

  private ensureHighlightObserver(): void {
    if (typeof window === 'undefined' || typeof document === 'undefined' || typeof MutationObserver === 'undefined') {
      return;
    }

    if (this.highlightObserver) {
      return;
    }

    const startObserving = () => {
      if (!document.body || this.highlightObserver) {
        return;
      }

      this.highlightObserver = new MutationObserver(() => {
        this.scheduleHighlightSync();
      });

      this.highlightObserver.observe(document.body, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    };

    if (document.body) {
      startObserving();
    } else {
      window.requestAnimationFrame(startObserving);
    }
  }

  private scheduleHighlightSync(): void {
    if (typeof window === 'undefined') {
      return;
    }

    if (this.highlightSyncScheduled) {
      return;
    }

    this.highlightSyncScheduled = true;
    window.requestAnimationFrame(() => {
      this.highlightSyncScheduled = false;
      this.syncVisibleHighlightContainers();
    });
  }

  private syncVisibleHighlightContainers(): void {
    this.syncHighlightWithTextarea('highlighted-content');
    this.syncHighlightWithTextarea('highlighted-content-specific');
    this.syncHighlightMirror();
  }

  private captureTextareaMirrorMetrics(): void {
    const textAreaOriginal = document.getElementById('Text-Area-Original');
    const textArea = document.getElementById('textArea') as HTMLTextAreaElement | null;

    if (!textAreaOriginal || !textArea) {
      return;
    }

    const textAreaRect = textArea.getBoundingClientRect();
    const fieldRect = textAreaOriginal.getBoundingClientRect();

    if (fieldRect.width <= 0 || textAreaRect.width <= 0) {
      return;
    }

    const textAreaStyles = window.getComputedStyle(textArea);
    this.lastTextareaMirrorMetrics = {
      fieldWidth: fieldRect.width,
      fieldHeight: fieldRect.height,
      textWidth: textAreaRect.width,
      textHeight: textAreaRect.height,
      paddingLeft: Math.max(0, textAreaRect.left - fieldRect.left) + parseFloat(textAreaStyles.paddingLeft || '0'),
      paddingTop: Math.max(0, textAreaRect.top - fieldRect.top) + parseFloat(textAreaStyles.paddingTop || '0'),
      paddingRight: Math.max(0, fieldRect.right - textAreaRect.right) + parseFloat(textAreaStyles.paddingRight || '0'),
      paddingBottom: Math.max(0, fieldRect.bottom - textAreaRect.bottom) + parseFloat(textAreaStyles.paddingBottom || '0'),
      marginBottom: window.getComputedStyle(textAreaOriginal).marginBottom,
      font: textAreaStyles.font,
      fontFamily: textAreaStyles.fontFamily,
      fontSize: textAreaStyles.fontSize,
      fontWeight: textAreaStyles.fontWeight,
      lineHeight: textAreaStyles.lineHeight,
      letterSpacing: textAreaStyles.letterSpacing,
      wordSpacing: textAreaStyles.wordSpacing,
      textTransform: textAreaStyles.textTransform,
      textIndent: textAreaStyles.textIndent,
      tabSize: textAreaStyles.tabSize
    };
  }

  private syncHighlightWithTextarea(containerId: 'highlighted-content' | 'highlighted-content-specific'): void {
    const highlightedContent = document.getElementById(containerId);
    const textAreaOriginal = document.getElementById('Text-Area-Original');
    const textArea = document.getElementById('textArea') as HTMLTextAreaElement | null;

    if (!highlightedContent || !textAreaOriginal || !textArea) {
      return;
    }

    this.captureTextareaMirrorMetrics();

    const metrics = this.lastTextareaMirrorMetrics;
    if (!metrics) {
      return;
    }

    highlightedContent.style.width = `${metrics.fieldWidth}px`;
    highlightedContent.style.minWidth = `${metrics.fieldWidth}px`;
    highlightedContent.style.minHeight = `${metrics.fieldHeight}px`;
    highlightedContent.style.paddingTop = `${metrics.paddingTop}px`;
    highlightedContent.style.paddingRight = `${metrics.paddingRight}px`;
    highlightedContent.style.paddingBottom = `${metrics.paddingBottom}px`;
    highlightedContent.style.paddingLeft = `${metrics.paddingLeft}px`;
    highlightedContent.style.font = metrics.font;
    highlightedContent.style.fontFamily = metrics.fontFamily;
    highlightedContent.style.fontSize = metrics.fontSize;
    highlightedContent.style.fontWeight = metrics.fontWeight;
    highlightedContent.style.lineHeight = metrics.lineHeight;
    highlightedContent.style.letterSpacing = metrics.letterSpacing;
    highlightedContent.style.wordSpacing = metrics.wordSpacing;
    highlightedContent.style.textTransform = metrics.textTransform;
    highlightedContent.style.textIndent = metrics.textIndent;
    highlightedContent.style.tabSize = metrics.tabSize;
    highlightedContent.style.marginTop = '0px';
    highlightedContent.style.marginBottom = metrics.marginBottom;
  }

  private syncHighlightMirror(): void {
    const highlightedMirror = document.getElementById('highlighted-content-mirror');
    const textAreaOriginal = document.getElementById('Text-Area-Original');

    if (!highlightedMirror || !textAreaOriginal || !this.pilotMirrorActive) {
      return;
    }

    this.captureTextareaMirrorMetrics();

    const metrics = this.lastTextareaMirrorMetrics;
    if (!metrics) {
      return;
    }

    highlightedMirror.style.width = `${metrics.fieldWidth}px`;
    highlightedMirror.style.minWidth = `${metrics.fieldWidth}px`;
    highlightedMirror.style.minHeight = `${metrics.fieldHeight}px`;
    highlightedMirror.style.paddingTop = `${metrics.paddingTop}px`;
    highlightedMirror.style.paddingRight = `${metrics.paddingRight}px`;
    highlightedMirror.style.paddingBottom = `${metrics.paddingBottom}px`;
    highlightedMirror.style.paddingLeft = `${metrics.paddingLeft}px`;
    highlightedMirror.style.font = metrics.font;
    highlightedMirror.style.fontFamily = metrics.fontFamily;
    highlightedMirror.style.fontSize = metrics.fontSize;
    highlightedMirror.style.fontWeight = metrics.fontWeight;
    highlightedMirror.style.lineHeight = metrics.lineHeight;
    highlightedMirror.style.letterSpacing = metrics.letterSpacing;
    highlightedMirror.style.wordSpacing = metrics.wordSpacing;
    highlightedMirror.style.textTransform = metrics.textTransform;
    highlightedMirror.style.textIndent = metrics.textIndent;
    highlightedMirror.style.tabSize = metrics.tabSize;
    highlightedMirror.style.marginTop = '0px';
    highlightedMirror.style.marginBottom = window.getComputedStyle(textAreaOriginal).marginBottom;
  }

  private teardownPilotMirror(clearPayload = true): void {
    const highlightedMirror = document.getElementById('highlighted-content-mirror');
    const textAreaShell = document.querySelector('.text-area-shell');

    if (highlightedMirror) {
      if (this.pilotMirrorInputHandler) {
        highlightedMirror.removeEventListener('input', this.pilotMirrorInputHandler);
      }
      if (this.pilotMirrorFocusHandler) {
        highlightedMirror.removeEventListener('focus', this.pilotMirrorFocusHandler);
      }
      this.pilotMirrorInputHandler = null;
      this.pilotMirrorFocusHandler = null;
      highlightedMirror.contentEditable = 'false';
      highlightedMirror.spellcheck = false;
      highlightedMirror.style.display = 'none';
      highlightedMirror.innerHTML = '';
      highlightedMirror.classList.remove(this.summaryHighlightClass);
      highlightedMirror.classList.remove('mirror-edit-overlay');
    }

    if (textAreaShell) {
      textAreaShell.classList.remove(this.pilotMirrorActiveClass);
      textAreaShell.classList.remove(this.pilotMirrorEditingClass);
    }

    this.pilotMirrorActive = false;
    if (clearPayload) {
      this.pilotMirrorPayload = null;
      this.pilotMirrorOriginalText = '';
    }
  }

  private showPilotMirrorHighlight(
    texto_modificado: string,
    options: {
      mode?: 'default' | 'summary';
      editable?: boolean;
    } = {}
  ): void {
    const {
      mode = 'default',
      editable = true
    } = options;

    const highlightedMirror = document.getElementById('highlighted-content-mirror');
    const highlightedContent = document.getElementById('highlighted-content');
    const highlightedContentSpecific = document.getElementById('highlighted-content-specific');
    const textAreaOriginal = document.getElementById('Text-Area-Original');
    const textAreaShell = document.querySelector('.text-area-shell');

    if (!highlightedMirror || !textAreaOriginal || !textAreaShell) {
      this.showHighlightedContent(texto_modificado, { mode, editable });
      return;
    }

    this.setHighlightDisplayMode(mode);

    if (highlightedContent) {
      highlightedContent.style.display = 'none';
      highlightedContent.innerHTML = '';
      highlightedContent.contentEditable = 'false';
    }

    if (highlightedContentSpecific) {
      highlightedContentSpecific.style.display = 'none';
      highlightedContentSpecific.innerHTML = '';
      highlightedContentSpecific.contentEditable = 'false';
    }

    textAreaOriginal.style.display = '';
    highlightedMirror.innerHTML = texto_modificado;
    highlightedMirror.style.display = 'block';
    highlightedMirror.contentEditable = 'false';
    highlightedMirror.spellcheck = false;
    highlightedMirror.classList.remove('mirror-edit-overlay');
    textAreaShell.classList.add(this.pilotMirrorActiveClass);
    textAreaShell.classList.remove(this.pilotMirrorEditingClass);
    this.pilotMirrorActive = true;
    this.pilotMirrorOriginalText = this.proyecto.text;
    this.pilotMirrorPayload = {
      html: texto_modificado,
      mode,
      editable
    };
    this.scheduleHighlightSync();
  }

  public promotePilotMirrorToLegacy(): void {
    if (!this.pilotMirrorActive || !this.pilotMirrorPayload) {
      return;
    }

    const payload = this.pilotMirrorPayload;
    this.teardownPilotMirror(false);
    this.showHighlightedContent(payload.html, {
      mode: payload.mode,
      editable: payload.editable
    });
  }

  public activatePilotMirrorEditing(): void {
    if (!this.pilotMirrorActive || !this.pilotMirrorPayload?.editable) {
      return;
    }

    const highlightedMirror = document.getElementById('highlighted-content-mirror');
    const textAreaShell = document.querySelector('.text-area-shell');
    const textArea = document.getElementById('textArea') as HTMLTextAreaElement | null;

    if (!highlightedMirror || !textAreaShell || !textArea) {
      this.teardownPilotMirror();
      return;
    }

    if (this.pilotMirrorInputHandler) {
      highlightedMirror.removeEventListener('input', this.pilotMirrorInputHandler);
    }
    if (this.pilotMirrorFocusHandler) {
      highlightedMirror.removeEventListener('focus', this.pilotMirrorFocusHandler);
    }

    highlightedMirror.classList.remove('mirror-edit-overlay');
    highlightedMirror.contentEditable = 'true';
    highlightedMirror.spellcheck = false;
    textAreaShell.classList.remove(this.pilotMirrorActiveClass);
    textAreaShell.classList.add(this.pilotMirrorEditingClass);

    this.pilotMirrorFocusHandler = () => {
      this.tuvoFocus = true;
    };

    this.pilotMirrorInputHandler = () => {
      const plainText = highlightedMirror.innerText.replace(/\u00A0/g, ' ').replace(/\r\n/g, '\n');
      textArea.value = plainText;
      textArea.dispatchEvent(new Event('input', { bubbles: true }));
      this.showEditEye(plainText.trim() !== this.pilotMirrorOriginalText.trim());
    };

    highlightedMirror.addEventListener('focus', this.pilotMirrorFocusHandler);
    highlightedMirror.addEventListener('input', this.pilotMirrorInputHandler);
    this.scheduleHighlightSync();
    requestAnimationFrame(() => {
      highlightedMirror.focus();
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(highlightedMirror);
      range.collapse(false);
      selection?.removeAllRanges();
      selection?.addRange(range);
    });
  }

  public deactivatePilotMirrorToTextarea(): void {
    this.activatePilotMirrorEditing();
  }

  private getActiveEditableHtml(): string {
    const highlightedMirror = document.getElementById('highlighted-content-mirror');
    const highlightedContent = document.getElementById('highlighted-content');
    const textAreaShell = document.querySelector('.text-area-shell');

    if (
      highlightedMirror &&
      highlightedMirror.style.display !== 'none' &&
      textAreaShell?.classList.contains(this.pilotMirrorEditingClass)
    ) {
      return highlightedMirror.innerHTML;
    }

    return highlightedContent?.innerHTML || '';
  }

  private showHighlightedContent(
    texto_modificado: string,
    options: {
      mode?: 'default' | 'summary';
      editable?: boolean;
      clearSpecific?: boolean;
    } = {}
  ): void {
    const {
      mode = 'default',
      editable = true,
      clearSpecific = true
    } = options;

    const highlightedContent = document.getElementById('highlighted-content');
    const highlightedContentSpecific = document.getElementById('highlighted-content-specific');
    const textAreaOriginal = document.getElementById('Text-Area-Original');

    if (!highlightedContent || !textAreaOriginal) {
      return;
    }

    this.teardownPilotMirror();
    this.setHighlightDisplayMode(mode);

    if (clearSpecific && highlightedContentSpecific) {
      highlightedContentSpecific.style.display = 'none';
      highlightedContentSpecific.innerHTML = '';
      highlightedContentSpecific.contentEditable = 'false';
    }

    textAreaOriginal.style.display = 'none';
    highlightedContent.style.display = '';
    highlightedContent.innerHTML = texto_modificado;
    highlightedContent.contentEditable = editable ? 'true' : 'false';
    this.scheduleHighlightSync();
  }

  private showHighlightedContentSpecific(
    texto_modificado: string,
    options: {
      editable?: boolean;
      hideMain?: boolean;
    } = {}
  ): void {
    const {
      editable = true,
      hideMain = true
    } = options;

    const highlightedContent = document.getElementById('highlighted-content');
    const highlightedContentSpecific = document.getElementById('highlighted-content-specific');
    const textAreaOriginal = document.getElementById('Text-Area-Original');

    if (!highlightedContentSpecific || !textAreaOriginal) {
      return;
    }

    this.teardownPilotMirror();
    this.setHighlightDisplayMode('default');

    if (hideMain && highlightedContent) {
      highlightedContent.style.display = 'none';
      highlightedContent.innerHTML = '';
      highlightedContent.contentEditable = 'false';
    }

    textAreaOriginal.style.display = 'none';
    highlightedContentSpecific.style.display = '';
    highlightedContentSpecific.innerHTML = texto_modificado;
    highlightedContentSpecific.contentEditable = editable ? 'true' : 'false';
    this.scheduleHighlightSync();
  }

  private resetHighlightEditingState(): void {
    this.teardownPilotMirror();
    this.setHighlightDisplayMode();

    const textAreaOriginal = document.getElementById('Text-Area-Original');
    const highlightedContent = document.getElementById('highlighted-content');
    const highlightedContentSpecific = document.getElementById('highlighted-content-specific');

    if (textAreaOriginal) {
      textAreaOriginal.style.display = '';
    }

    if (highlightedContent) {
      highlightedContent.style.display = 'none';
      highlightedContent.innerHTML = '';
      highlightedContent.contentEditable = 'false';
    }

    if (highlightedContentSpecific) {
      highlightedContentSpecific.style.display = 'none';
      highlightedContentSpecific.innerHTML = '';
      highlightedContentSpecific.contentEditable = 'false';
    }

    this.updateEditEye(false);
    this.showEditEye(false);
    this.tuvoFocus = false;
    this.valueCopy.next(true);
  }

  proyectoGuardado() {
    this.proyectoGuardadoSubject.next();
  }

  public createValue = new BehaviorSubject<boolean>(false);
  valueCreate$ = this.createValue.asObservable();

  private refrescarPorLogin = new BehaviorSubject<void>(null);
  public refrescarL$ = this.refrescarPorLogin.asObservable();

  cleanTextbyLogin() {
    this.refrescarPorLogin.next();
  }

  private limitProjects = new BehaviorSubject<boolean>(false);
  limitOfProjects$ = this.limitProjects.asObservable();

  updateDisablelimitOfProjects(limitOfProjects: boolean): void {
    this.limitProjects.next(limitOfProjects);
  }

   private limitProjectsP = new BehaviorSubject<boolean>(false);
  limitOfProjectsP$ = this.limitProjectsP.asObservable();

  updateDisablelimitOfProjectsProfile(limitOfProjectsP: boolean): void {
    this.limitProjectsP.next(limitOfProjectsP);
  }

  
  private limitWords = new BehaviorSubject<boolean>(false);
  limitOfWords$ = this.limitWords.asObservable();

  updateDisablelimitOfWords(limitOfWords: boolean): void {
    this.limitWords.next(limitOfWords);
  }

    private isEditCategory = new BehaviorSubject<boolean>(false);
  isEditCategory$ = this.isEditCategory.asObservable();

  updateEditCategory(isEditCategory: boolean): void {
    this.isEditCategory.next(isEditCategory);
  }

  private valueEditCategory = new BehaviorSubject<String>("");
  valueEditCategory$ = this.valueEditCategory.asObservable();

  updateValueEditCategory(valueEditCategory: String): void {
    this.valueEditCategory.next(valueEditCategory);
  }

  private deleteSameProjectToStorage = new BehaviorSubject<boolean>(false);
  deleteSameProjectOfStorage$ = this.deleteSameProjectToStorage.asObservable();

  checkDeleteSameProjectToStorage(deleteSameProjectOfStorage: boolean): void {
    this.deleteSameProjectToStorage.next(deleteSameProjectOfStorage);
  }

  private creatingDisabled = new BehaviorSubject<boolean>(false);
  creatingProject$ = this.creatingDisabled.asObservable();

  updateDisableCreatingProject(creatingProject: boolean): void {
    this.creatingDisabled.next(creatingProject);
  }

  private creatingDisabledAnalysis = new BehaviorSubject<boolean>(false);
  creatingProjectAnalysis$ = this.creatingDisabledAnalysis.asObservable();

  updateDisableCreatingProjectAnalysis(creatingProjectAnalysis: boolean): void {
    this.creatingDisabledAnalysis.next(creatingProjectAnalysis);
  }

   private limitOfDocuments = new BehaviorSubject<boolean>(false);
  limitOfDocuments$ = this.limitOfDocuments.asObservable();

  updateLimitOfDocuments(limitOfDocuments: boolean): void {
    this.limitOfDocuments.next(limitOfDocuments);
  }

  private limitProfileUsers = new Subject<boolean>();
  limitProfileUsers$ = this.limitProfileUsers.asObservable();

  updatelimitProfileUsers(limitProfileUsers: boolean): void {
    this.limitProfileUsers.next(limitProfileUsers);
  }

  private messageProfileUsers = new Subject<string>();
  messageProfileUsers$ = this.messageProfileUsers.asObservable();

  sendMessageProfileUsers(messageProfileUsers: string): void {
    this.messageProfileUsers.next(messageProfileUsers);
  }

  private loaderSubject = new BehaviorSubject<boolean>(false);
  loader$ = this.loaderSubject.asObservable();

  updateloader(loader: boolean): void {
    this.loaderSubject.next(loader);
  }

    private loaderAnalyzing = new Subject<boolean>();
  loaderAnalyzing$ = this.loaderAnalyzing.asObservable();

  updateloaderAnalyzing(loaderAnalyzing: boolean): void {
    this.loaderAnalyzing.next(loaderAnalyzing);
  }

      private verifyloaderAnalyzing = new Subject<boolean>(); //Se crea por el problema de que quitaba el spinner de Analyzing and Saving y lo volvia a poner al entrar a la peticion de una pestaña
  verifyloaderAnalyzing$ = this.verifyloaderAnalyzing.asObservable();

  verifyLoaderAnalyzing(verifyloaderAnalyzing: boolean): void {
    this.verifyloaderAnalyzing.next(verifyloaderAnalyzing);
  }

  private loaderCreatingProject = new Subject<boolean>();
  loaderCreatingProject$ = this.loaderCreatingProject.asObservable();

  updateloaderCreatingProject(loaderCreatingProject: boolean): void {
    this.loaderCreatingProject.next(loaderCreatingProject);
  }

  private banderaTextoVacio = new BehaviorSubject<boolean>(false);
  banderaT$ = this.banderaTextoVacio.asObservable();

  updateBanderaTextoVacio(banderaT: boolean): void {
    this.banderaTextoVacio.next(banderaT);
  }

  private banderaFile = new BehaviorSubject<boolean>(false);
  banderaF$ = this.banderaFile.asObservable();

  updateBanderaFile(banderaF: boolean): void {
    this.banderaFile.next(banderaF);
  }

  private banderaErrors = new BehaviorSubject<boolean>(false);
  banderaE$ = this.banderaErrors.asObservable();

  updateBanderaErrors(banderaE: boolean): void {
    this.banderaErrors.next(banderaE);
  }

   private banderaLimpiarTexto = new BehaviorSubject<boolean>(false);
  banderaLimpiarTexto$ = this.banderaLimpiarTexto.asObservable();

  updateBanderaLimpiarTexto(banderaLimpiarTexto: boolean): void { // Se crea esta bandera para evitar que siga el limite de palabras (No exitosa)
    this.banderaLimpiarTexto.next(banderaLimpiarTexto);
  }

  // Variable para detectar si es menor de 100 palabras y mostrar mensaje en Readability y Scorecard
  private wordCountSubject = new BehaviorSubject<boolean>(true);
  wordCount$ = this.wordCountSubject.asObservable();

  updateWordCountStatus(isLessThan100: boolean): void {
    this.wordCountSubject.next(isLessThan100);
  }
  //-------------------------------------------------------------------



  private callUpdateApiPage = new Subject<boolean>();
  callUpdateApiPage$ = this.callUpdateApiPage.asObservable();

  updatecallUpdateApiPage(callUpdateApiPage: boolean): void {
    this.callUpdateApiPage.next(callUpdateApiPage);
  }

  private profilePage = new Subject<boolean>();
  profilePage$ = this.profilePage.asObservable();

  updateprofilePage(profilePage: boolean): void {
    this.profilePage.next(profilePage);
  }

  deleteProyect: boolean = false;

  constructor(public fachada: FacadeService) { 
    this.ensureHighlightObserver();
    this.loadProjectIdFromSessionStorage;
  }
  
  private dataSubject = new BehaviorSubject<any>({ proyecto: this.proyecto, firstProject: this.firstProject });

  proyecto$ = this.dataSubject.asObservable();

  getdata(){
    return this.proyecto;
  }

  // Método para limpiar claves específicas de sessionStorage 
  clearKeysSessionStorage() { 
      sessionStorage.removeItem('id_project'); 
      sessionStorage.removeItem('text_UID'); 
      this.limpiarPestañasStorage();
    }

  limpiarPestañasStorage(){
    sessionStorage.removeItem('summary');
    sessionStorage.removeItem('summaryP2');
    sessionStorage.removeItem('summaryP3');
    sessionStorage.removeItem('summaryP4');
    sessionStorage.removeItem('statistics');
    sessionStorage.removeItem('readability');
    sessionStorage.removeItem('errors');
    sessionStorage.removeItem('lexical');
    sessionStorage.removeItem('tagger');
    sessionStorage.removeItem('evp');
    sessionStorage.removeItem('kvl');
    sessionStorage.removeItem('coca');
    sessionStorage.removeItem('awl');
    sessionStorage.removeItem('meta');
    sessionStorage.removeItem('score');
    sessionStorage.removeItem('data_wordlist');
    sessionStorage.removeItem('analysis_op');
  }

  // Guardar el id_project en sessionStorage 
  saveProjectIdToSessionStorage(id_project: string, text_UID: string) {
    sessionStorage.setItem('id_project', id_project);
    sessionStorage.setItem('text_UID', text_UID);
  }

  // Cargar el id_project desde sessionStorage 
  loadProjectIdFromSessionStorage() { 
    const storedId = sessionStorage.getItem('id_project'); 
    const storedTextUID = sessionStorage.getItem('text_UID'); 
    if (storedId) { this.proyecto.id_project = storedId; } 
    if (storedTextUID) { this.proyecto.text_UID = storedTextUID;
    }
  } 
  
  // // Método para actualizar el id_project y guardarlo en sessionStorage 
  // updateProjectId(newId: string, newTextUID: string) { 
  //   this.proyecto.id_project = newId; 
  //   this.proyecto.text_UID = newTextUID; 
  //   this.saveProjectIdToSessionStorage(newId, newTextUID); 
  //   // Iniciar temporizador para borrar los datos del proyecto 
  //   this.dataSubject.next(this.proyecto);
  // }



  public realizarMarcado(palabras:Array<String>, etiqueta:string,http){
    etiqueta = etiqueta.replaceAll(".","-")
    // let texto_modificado = this.proyecto.texto_modificado
    // if (texto_modificado==''){
    // }
    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);
    for (let index = 0; index < palabras.length; index++) {
      let palabra = palabras[index];
      if (this.palabra_baneada(palabra)){
        texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta);
      }else{
        texto_modificado = this.marcarPalabraFueraDeTags(texto_modificado, palabra, etiqueta);
        //Ver como normalizar texto
      }
    }
    this.proyecto.texto_modificado = texto_modificado
    this.showHighlightedContent(texto_modificado);

    this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });
     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
  // this.messageValue.next(true);

    this.valueCopy.next(false);
  }

  public realizarMarcadoCocaFree(palabras:Array<String>, etiqueta:string){
    etiqueta = etiqueta.replaceAll(".","-")
    // let texto_modificado = this.proyecto.texto_modificado
    // if (texto_modificado==''){
    // }
    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);
    for (let index = 0; index < palabras.length; index++) {
      let palabra = palabras[index];
      if (this.palabra_baneada(palabra)){
        texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta);
      }else{
        texto_modificado = this.marcarPalabraFueraDeTags(texto_modificado, palabra, etiqueta);
        //Ver como normalizar texto
      }
    }
    this.proyecto.texto_modificado = texto_modificado
    this.showHighlightedContent(texto_modificado, { editable: false });
    this.messageValue.next(true);

    this.valueCopy.next(false);
  }

 public realizarMarcadoTodasLasCategorias(categoriasActivas: any[], http: any): void {
  let texto_modificado = this.proyecto.text.replace(/\n/g, `<br>`);

  categoriasActivas.forEach(item => {
      let etiqueta = item.label.replaceAll(".", "-");

      const palabras = Object.keys(item.words);

      palabras.forEach(palabra => {
        if (this.palabra_baneada(palabra)) {
          texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta);
        } else {
          texto_modificado = this.marcarPalabraFueraDeTags(texto_modificado, palabra, etiqueta);
        }
      });
  });

  this.proyecto.texto_modificado = texto_modificado;
  this.showHighlightedContent(texto_modificado);
  this.blurHandler = () => this.terminarEdicionErrores(http);

  document.getElementById('highlighted-content')!.addEventListener('focus', () => {
    this.tuvoFocus = true;
  });

  document.getElementById('highlighted-content')!.addEventListener('input', () => {
    const original = this.proyecto.text;
    const actual = document.getElementById('highlighted-content')!.innerText.trim();
    this.showEditEye(actual !== original.trim());
  });

  // this.messageValue.next(true);
  this.valueCopy.next(false);
}



  public realizarMarcadoKvlFree(palabras:Array<String>, etiqueta:string){
    etiqueta = etiqueta.replaceAll(".","-")
    // let texto_modificado = this.proyecto.texto_modificado
    // if (texto_modificado==''){
    // }
    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);
    for (let index = 0; index < palabras.length; index++) {
      let palabra = palabras[index];
      if (this.palabra_baneada(palabra)){
        texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta);
      }else{
        texto_modificado = this.marcarPalabraFueraDeTags(texto_modificado, palabra, etiqueta);
        //Ver como normalizar texto
      }
    }
    this.proyecto.texto_modificado = texto_modificado
    this.showHighlightedContent(texto_modificado, { editable: false });
    this.messageValue.next(true);

    this.valueCopy.next(false);
  }

   public realizarMarcado3(palabras:Array<String>, etiqueta:string,){
    etiqueta = etiqueta.replaceAll(".","-")
    // let texto_modificado = this.proyecto.texto_modificado
    // if (texto_modificado==''){
    // }
    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);
    for (let index = 0; index < palabras.length; index++) {
      let palabra = palabras[index];
      if (this.palabra_baneada(palabra)){
        texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta);
      }else{
        texto_modificado = this.marcarPalabraFueraDeTags(texto_modificado, palabra, etiqueta);
        //Ver como normalizar texto
      }
    }
    this.proyecto.texto_modificado = texto_modificado
    this.showHighlightedContent(texto_modificado, { editable: false });
    this.messageValue.next(true);

    this.valueCopy.next(false);
  }

  public realizarMarcado3Summary(palabras:Array<String>, etiqueta:string,http){
    etiqueta = etiqueta.replaceAll(".","-")
    // let texto_modificado = this.proyecto.texto_modificado
    // if (texto_modificado==''){
    // }
    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);
    for (let index = 0; index < palabras.length; index++) {
      let palabra = palabras[index];
      if (this.palabra_baneada(palabra)){
        texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta);
      }else{
        texto_modificado = this.marcarPalabraFueraDeTags(texto_modificado, palabra, etiqueta);
        //Ver como normalizar texto
      }
    }
    this.proyecto.texto_modificado = texto_modificado
    // Mirror pilot paused. Keep the new path nearby for a quick rollback if needed.
    // this.showPilotMirrorHighlight(texto_modificado, { mode: 'summary', editable: true });
    this.showHighlightedContent(texto_modificado, { mode: 'summary' });
    this.valueCopy.next(false);
  }

 public realizarMarcado3Statis(palabras: Array<string>, etiqueta: string, http) {
  etiqueta = etiqueta.replaceAll(".", "-");
  let texto_modificado = this.proyecto.text;

  // Reemplazar saltos de línea por <br>
  const salto = new RegExp(`(\n)`, 'gi');
  texto_modificado = texto_modificado.replace(salto, `<br>`);

  for (let index = 0; index < palabras.length; index++) {
    let palabra = palabras[index];

    if (this.palabra_baneada(palabra)) {
      texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta);
      continue;
    }

    // Verifica si la palabra ya está etiquetada
    const escapedWord = palabra.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const etiquetaRegex = new RegExp(`<ttg-${etiqueta}>${escapedWord}</ttg-${etiqueta}>`, 'i');
    if (etiquetaRegex.test(texto_modificado)) {
      continue; // Ya está etiquetada, no volver a marcar
    }

    // Etiquetar la palabra
    texto_modificado = this.marcarPalabraFueraDeTags(texto_modificado, palabra, etiqueta);
  }

  this.proyecto.texto_modificado = texto_modificado;
  this.showHighlightedContent(texto_modificado);

  this.blurHandler = () => this.terminarEdicionErrores(http);
  document.getElementById('highlighted-content')!.addEventListener('focus', () => {
    this.tuvoFocus = true;
  });
  // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
   document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
  this.valueCopy.next(false);
}

  public realizarMarcadoErrorsFree(palabras:Array<String>, etiqueta:string){
    etiqueta = etiqueta.replaceAll(".","-")
    // let texto_modificado = this.proyecto.texto_modificado
    // if (texto_modificado==''){
    // }
    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);
    for (let index = 0; index < palabras.length; index++) {
      let palabra = palabras[index];
      if (this.palabra_baneada(palabra)){
        texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta);
      }else{
        texto_modificado = this.marcarPalabraFueraDeTags(texto_modificado, palabra, etiqueta);
        //Ver como normalizar texto
      }
    }
    this.proyecto.texto_modificado = texto_modificado
    this.showHighlightedContent(texto_modificado, { editable: false });
    this.messageValue.next(true);
    this.valueCopy.next(false);
  }

  public realizarMarcadoErrors(palabras:Array<String>, etiqueta:string, http){
    etiqueta = etiqueta.replaceAll(".","-")
    // let texto_modificado = this.proyecto.texto_modificado
    // if (texto_modificado==''){
    // }
    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);
    for (let index = 0; index < palabras.length; index++) {
      let palabra = palabras[index];
      if (this.palabra_baneada(palabra)){
        texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta);
      }else{
        const regex = this.buildFlexibleErrorRegex(palabra);

        texto_modificado = texto_modificado.replace(regex, (_match, prefix, word) => `${prefix}<ttg-${etiqueta}>${word}</ttg-${etiqueta}>`);
        //Ver como normalizar texto
      }
    }
    this.proyecto.texto_modificado = texto_modificado
    this.showHighlightedContent(texto_modificado, { editable: true });
    this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

      document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);

    // this.messageValue.next(true);
    this.valueCopy.next(false);
  }

  private buildFlexibleErrorRegex(phrase: String): RegExp {
    const source = String(phrase);
    let pattern = '';

    for (const char of source) {
      if (/\s/.test(char)) {
        pattern += '(?:\\s|<br>)+';
        continue;
      }

      if (/["“”]/.test(char)) {
        pattern += '["“”]?';
        continue;
      }

      if (/['’´]/.test(char)) {
        pattern += "['’´]?";
        continue;
      }

      if (char === '-') {
        pattern += '[-–—]?';
        continue;
      }

      pattern += char.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    return new RegExp(`(^|[^A-Za-z0-9_])(${pattern})(?![A-Za-z0-9_])`, 'gi');
  }

  private showEdit_Eye = new BehaviorSubject<boolean>(false);
  showEditEye$ = this.showEdit_Eye.asObservable();

  showEditEye(showEditEye: boolean): void {
    this.showEdit_Eye.next(showEditEye);
  }

  private edit_Eye = new BehaviorSubject<boolean>(false);
  editEye$ = this.edit_Eye.asObservable();

  updateEditEye(editEye: boolean): void {
    this.edit_Eye.next(editEye);
  }

  terminarEdicionErrores = async (http: any) => {
    if (this.tuvoFocus){

      const html = this.getActiveEditableHtml();
      const limpio = this.limpiarHTMLPersonalizado(html);

    
      try {
        const id = sessionStorage.getItem("id_project");
        if (!id || limpio === "") return;
    
        let response = await this.fachada.getInfoProyect(http, id);
        let text_data = response;
        
        

        
         // Validación para no hacer nada si el texto no ha cambiado
        if (text_data.text !== limpio) {
          if(this.edit_Eye.getValue()){ 
              this.updateloader(true);
              text_data.text = limpio;
              response = await this.fachada.UpdateTextofProyect(http, text_data);
              this.updateData(response);
             }else{
          text_data = response;
        }
        }
       
    
      } catch (error) {
        console.error("No se puede recuperar el proyecto", error);
      } finally {
        this.updateloader(false);
        this.verifyLoaderAnalyzing(false);
        this.updateloaderAnalyzing(false);
        this.resetHighlightEditingState();
      }
    }
    
    
  };
  
  terminarEdicionErrores2 = async (http: any) => {
    if (this.tuvoFocus){
      const html = this.getActiveEditableHtml() || document.getElementById('highlighted-content-specific')!.innerHTML;
      const limpio = this.limpiarHTMLPersonalizado(html);
  
    
      try {
        const id = sessionStorage.getItem("id_project");
        if (!id || limpio === "") return;
    
        let response = await this.fachada.getInfoProyect(http, id);
        let text_data = response;
        // Validación para no hacer nada si el texto no ha cambiado
        if (text_data.text !== limpio) {
          if(this.edit_Eye.getValue()){
            this.updateloader(true);
          text_data.text = limpio;
          response = await this.fachada.UpdateTextofProyect(http, text_data);
          this.updateData(response);
        }
        else{
          text_data = response;
        }
      }
      } catch (error) {
        console.error("No se puede recuperar el proyecto", error);
      } finally {
        this.updateloader(false);
        this.verifyLoaderAnalyzing(false);
        this.updateloaderAnalyzing(false);
        this.resetHighlightEditingState();
      }
    }
  };  

  public realizarMarcado2(palabras: Array<string>, etiqueta: string) {
    etiqueta = etiqueta.replaceAll(".", "-");
    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);
  
    for (let index = 0; index < palabras.length; index++) {
      let palabra = palabras[index];
    
      // Saltar si está baneada o si es muy corta
      if (this.palabra_baneada(palabra)) {
        texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta);
        continue;
      }

      if (palabra.length < 3 || !/^[a-zA-Z]+$/.test(palabra)) {
        continue;
      }
    
      texto_modificado = this.marcarPalabraFueraDeTags(texto_modificado, palabra, etiqueta);
    }
    

    this.proyecto.texto_modificado = texto_modificado;
    this.showHighlightedContent(texto_modificado);
    this.messageValue.next(true);
    this.valueCopy.next(false);
  }

  public realizarMarcado2Statis(palabras: Array<string>, etiqueta: string,http) {
    etiqueta = etiqueta.replaceAll(".", "-");
    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);
  
    for (let index = 0; index < palabras.length; index++) {
      let palabra = palabras[index];
    
      // Saltar si está baneada o si es muy corta
      if (this.palabra_baneada(palabra)) {
        texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta);
        continue;
      }

      if (palabra.length < 3 || !/^[a-zA-Z]+$/.test(palabra)) {
        continue;
      }
    
      texto_modificado = this.marcarPalabraFueraDeTags(texto_modificado, palabra, etiqueta);
    }
    

    this.proyecto.texto_modificado = texto_modificado;
    this.showHighlightedContent(texto_modificado, { editable: true });
    this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
    this.valueCopy.next(false);
  }

  public realizarMarcadoTokensWords(palabras: Array<string>, etiqueta: string) {
    etiqueta = etiqueta.replaceAll(".", "-");
    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);
  
    for (let index = 0; index < palabras.length; index++) {
      let palabra = palabras[index];
      // Saltar si está baneada o si es muy corta
      if (this.palabra_baneada(palabra)) {
        texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta);
        continue;
      }
    
      texto_modificado = this.marcarPalabraFueraDeTags(texto_modificado, palabra, etiqueta);
    }
    
    this.proyecto.texto_modificado = texto_modificado;
    this.showHighlightedContent(texto_modificado);
    this.messageValue.next(true);
    this.valueCopy.next(false);
  }

  public realizarMarcadoTokensWordsSummary(palabras: Array<string>, etiqueta: string,http) {
    etiqueta = etiqueta.replaceAll(".", "-");
    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);
  
    for (let index = 0; index < palabras.length; index++) {
      let palabra = palabras[index];
      // Saltar si está baneada o si es muy corta
      if (this.palabra_baneada(palabra)) {
        texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta);
        continue;
      }
    
      texto_modificado = this.marcarPalabraFueraDeTags(texto_modificado, palabra, etiqueta, 'i');
    }
    
    this.proyecto.texto_modificado = texto_modificado;
    // Mirror pilot paused. Keep the new path nearby for a quick rollback if needed.
    // this.showPilotMirrorHighlight(texto_modificado, { mode: 'summary', editable: true });
    this.showHighlightedContent(texto_modificado, { mode: 'summary' });
    this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
    this.valueCopy.next(false);
  }

  public realizarMarcadoTokensWordsStatis(palabras: Array<string>, etiqueta: string,http) {
    etiqueta = etiqueta.replaceAll(".", "-");
    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);
  
    for (let index = 0; index < palabras.length; index++) {
      let palabra = palabras[index];
      // Saltar si está baneada o si es muy corta
      if (this.palabra_baneada(palabra)) {
        texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta);
        continue;
      }
    
      texto_modificado = this.marcarPalabraFueraDeTags(texto_modificado, palabra, etiqueta, 'i');
    }
    
    this.proyecto.texto_modificado = texto_modificado;
    this.showHighlightedContent(texto_modificado, { editable: true });
    this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
    this.valueCopy.next(false);
  }

  public realizarMarcadoUniqueTokens(palabras: Array<string>, etiqueta: string) {
    etiqueta = etiqueta.replaceAll(".", "-");
    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);
  
    for (let index = 0; index < palabras.length; index++) {
      let palabra = palabras[index];
    
      // Saltar si está baneada o si es muy corta
      if (this.palabra_baneada(palabra)) {
        texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta);
        continue;
      }
    
      texto_modificado = this.marcarPalabraFueraDeTags(texto_modificado, palabra, etiqueta);
    }
    
  
    this.proyecto.texto_modificado = texto_modificado;
    this.showHighlightedContent(texto_modificado);
    this.messageValue.next(true);
    this.valueCopy.next(false);
  }

  public realizarMarcadoUniqueTokensStatis(palabras: Array<string>, etiqueta: string,http) {
    etiqueta = etiqueta.replaceAll(".", "-");
    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);
  
    for (let index = 0; index < palabras.length; index++) {
      let palabra = palabras[index];
    
      // Saltar si está baneada o si es muy corta
      if (this.palabra_baneada(palabra)) {
        texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta);
        continue;
      }
    
      texto_modificado = this.marcarPalabraFueraDeTags(texto_modificado, palabra, etiqueta, 'i');
    }
    
  
    this.proyecto.texto_modificado = texto_modificado;
    this.showHighlightedContent(texto_modificado, { editable: true });
    this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });
     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });

    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
    this.valueCopy.next(false);
  }
  


  public resaltarCoincidenciaOrdenada(palabra: string, categoria: string, posiciones: { posicion: number; categoria: string }[], orden: number,http): void {
    let texto_modificado = this.proyecto.text;

    // Reemplazar saltos de línea para manejar el formato correctamente
    texto_modificado = texto_modificado.replace(/\n/g, `<br>`);

    let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, 'gi');


    if (coincidenciasEncontradas.length >= orden) {
        const coincidenciaSeleccionada = coincidenciasEncontradas[orden - 1];
        const palabraOriginal = coincidenciaSeleccionada.text;
        const inicio = coincidenciaSeleccionada.index;
        const fin = inicio + palabraOriginal.length;

        texto_modificado = texto_modificado.substring(0, inicio) + `<ttg-${categoria}>${palabraOriginal}</ttg-${categoria}>` + texto_modificado.substring(fin);

    } else {
    }

    this.proyecto.texto_modificado = texto_modificado;
    this.showHighlightedContentSpecific(texto_modificado);
    this.blurHandler = () => this.terminarEdicionErrores2(http);
   document.getElementById('highlighted-content-specific')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content-specific')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content-specific')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content-specific')!.addEventListener('blur', this.blurHandler);
    // this.messageValue.next(true);

    this.valueCopy.next(false);
  }

  public resaltarCoincidenciaOrdenadaTagger(palabra: string, categoria: string, posiciones: { posicion: number; categoria: string }[], orden: number,http): void {
    let texto_modificado = this.proyecto.text;

    // Reemplazar saltos de línea para manejar el formato correctamente
    texto_modificado = texto_modificado.replace(/\n/g, `<br>`);

    let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, 'gi');


    if (coincidenciasEncontradas.length >= orden) {
        const coincidenciaSeleccionada = coincidenciasEncontradas[orden - 1];
        const palabraOriginal = coincidenciaSeleccionada.text;
        const inicio = coincidenciaSeleccionada.index;
        const fin = inicio + palabraOriginal.length;

        let categoriaFinal = categoria;

         if ("???" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extra";
             }
           if ("," === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraS";
             }
             if (":" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraT";
             }
              if ("$" === categoriaFinal.toUpperCase()) {
               categoriaFinal = "extraF";
             }

        const categoriaUpper = categoriaFinal.toUpperCase();
        let tagCategoria = categoriaUpper === 'PP$' ? 'PP2' : categoriaUpper;
        texto_modificado = texto_modificado.substring(0, inicio) + `<ttg-${tagCategoria}>${palabraOriginal}</ttg-${tagCategoria}>` + texto_modificado.substring(fin);

    } else {
    }

    this.proyecto.texto_modificado = texto_modificado;
    this.showHighlightedContentSpecific(texto_modificado);
    this.blurHandler = () => this.terminarEdicionErrores2(http);
   document.getElementById('highlighted-content-specific')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content-specific')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content-specific')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content-specific')!.addEventListener('blur', this.blurHandler);
    // this.messageValue.next(true);
    this.valueCopy.next(false);
  }

   public resaltarCoincidenciaOrdenadaTaggerFree(palabra: string, categoria: string, posiciones: { posicion: number; categoria: string }[], orden: number): void {
    let texto_modificado = this.proyecto.text;

    // Reemplazar saltos de línea para manejar el formato correctamente
    texto_modificado = texto_modificado.replace(/\n/g, `<br>`);

    let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, 'gi');


    if (coincidenciasEncontradas.length >= orden) {
        const coincidenciaSeleccionada = coincidenciasEncontradas[orden - 1];
        const palabraOriginal = coincidenciaSeleccionada.text;
        const inicio = coincidenciaSeleccionada.index;
        const fin = inicio + palabraOriginal.length;

          let categoriaFinal = categoria;
           if ("???" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extra";
             }
           if ("," === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraS";
             }
             if (":" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraT";
             }
              if ("$" === categoriaFinal.toUpperCase()) {
               categoriaFinal = "extraF";
             }


             const categoriaUpper = categoriaFinal.toUpperCase();
        let tagCategoria = categoriaUpper === 'PP$' ? 'PP2' : categoriaUpper;
        texto_modificado = texto_modificado.substring(0, inicio) + `<ttg-${tagCategoria}>${palabraOriginal}</ttg-${tagCategoria}>` + texto_modificado.substring(fin);

    } else {
    }

    this.proyecto.texto_modificado = texto_modificado;
    this.showHighlightedContentSpecific(texto_modificado, { editable: false });
    this.messageValue.next(true);
    this.valueCopy.next(false);
  }
  

  public resaltarMultiplesCoincidencias(
    palabras: string[],
    categoria: string,
    posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] },
    http
  ): void {
    let texto_modificado = this.proyecto.text;
  
    // Reemplazar saltos de línea para manejar el formato correctamente
    texto_modificado = texto_modificado.replace(/\n/g, `<br>`);
  
    palabras.forEach(palabra => {
      const posiciones = posicionesPorPalabra[palabra] || [];
  
      if (posiciones.length === 0) {
        console.warn(`No hay posiciones almacenadas para la palabra "${palabra}".`);
        return;
      }
  
      // Revisar si hay otras variaciones de esa palabra con distinta capitalización en la misma categoría
      const palabrasCategoria = Object.keys(posicionesPorPalabra).filter(p =>
        posicionesPorPalabra[p].some(pos => pos.categoria === categoria)
      );
  
      const palabraLower = palabra.toLowerCase();
      const tieneVariaciones = palabrasCategoria.some(p => p.toLowerCase() === palabraLower && p !== palabra);
  
      const flags = tieneVariaciones ? 'g' : 'gi';
      let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, flags);
  

  
      if (coincidenciasEncontradas.length === 0) {
        return;
      }
  
      let posicionesValidas = posiciones.map(p => p.posicion).sort((a, b) => a - b);
      let textoFinal = texto_modificado;
      let desplazamiento = 0;
  
      posicionesValidas.forEach((posicionSeleccionada, index) => {
        if (index >= coincidenciasEncontradas.length) return;
  
        let coincidenciaSeleccionada = coincidenciasEncontradas[index];
        let palabraOriginal = coincidenciaSeleccionada[0];
        let inicio = coincidenciaSeleccionada.index! + desplazamiento;
        let fin = inicio + palabraOriginal.length;
  
        const categoriaCorrecta = posiciones.some(p => p.posicion === posicionSeleccionada && p.categoria === categoria);
  
        if (categoriaCorrecta) {
          let palabraResaltada = `<ttg-${categoria}>${palabraOriginal}</ttg-${categoria}>`;
  
          textoFinal =
            textoFinal.substring(0, inicio) +
            palabraResaltada +
            textoFinal.substring(fin);
  
          desplazamiento += palabraResaltada.length - palabraOriginal.length;
        }
      });
  
      texto_modificado = textoFinal;
    });
  
  
    this.proyecto.texto_modificado = texto_modificado;
    this.showHighlightedContent(texto_modificado);
    this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
  // this.messageValue.next(true);
    this.valueCopy.next(false);
  }

  public resaltarMultiplesCoincidenciasTagger(
    palabras: string[],
    categoria: string,
    posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] },
    http
  ): void {

    let texto_modificado = this.proyecto.text;
  
    // Reemplazar saltos de línea para manejar el formato correctamente
    texto_modificado = texto_modificado.replace(/\n/g, `<br>`);
  
    palabras.forEach(palabra => {
      const posiciones = posicionesPorPalabra[palabra] || [];
  
      if (posiciones.length === 0) {
        console.warn(`No hay posiciones almacenadas para la palabra "${palabra}".`);
        return;
      }
  
      // Revisar si hay otras variaciones de esa palabra con distinta capitalización en la misma categoría
      const palabrasCategoria = Object.keys(posicionesPorPalabra).filter(p =>
        posicionesPorPalabra[p].some(pos => pos.categoria === categoria)
      );
  
      const palabraLower = palabra.toLowerCase();
      const tieneVariaciones = palabrasCategoria.some(p => p.toLowerCase() === palabraLower && p !== palabra);
  
      const flags = tieneVariaciones ? 'g' : 'gi';
      let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, flags);
  

  
      if (coincidenciasEncontradas.length === 0) {
        console.error(`No se encontraron instancias de "${palabra}" en el texto.`);
        return;
      }
  
      let posicionesValidas = posiciones.map(p => p.posicion).sort((a, b) => a - b);
      let textoFinal = texto_modificado;
      let desplazamiento = 0;
  
      posicionesValidas.forEach((posicionSeleccionada, index) => {
        if (index >= coincidenciasEncontradas.length) return;
  
        let coincidenciaSeleccionada = coincidenciasEncontradas[index];
        let palabraOriginal = coincidenciaSeleccionada[0];
        let inicio = coincidenciaSeleccionada.index! + desplazamiento;
        let fin = inicio + palabraOriginal.length;
  
        const categoriaCorrecta = posiciones.some(p => p.posicion === posicionSeleccionada && p.categoria === categoria);
  
        if (categoriaCorrecta) {
          let categoriaFinal = categoria;

           if ("???" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extra";
             }
           if ("," === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraS";
             }
             if (":" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraT";
             }
              if ("$" === categoriaFinal.toUpperCase()) {
               categoriaFinal = "extraF";
             }


          const categoriaUpper = categoriaFinal.toUpperCase();
          let tagCategoria = categoriaUpper === 'PP$' ? 'PP2' : categoriaUpper;
          let palabraResaltada = `<ttg-${tagCategoria}>${palabraOriginal}</ttg-${tagCategoria}>`;
  
          textoFinal =
            textoFinal.substring(0, inicio) +
            palabraResaltada +
            textoFinal.substring(fin);
  
          desplazamiento += palabraResaltada.length - palabraOriginal.length;
        }
      });
  
      texto_modificado = textoFinal;
    });
  
  
    this.proyecto.texto_modificado = texto_modificado;
    this.showHighlightedContent(texto_modificado);
    this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
  // this.messageValue.next(true);
    this.valueCopy.next(false);
  }

  public resaltarMultiplesCoincidenciasTaggerFree(
    palabras: string[],
    categoria: string,
    posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] }
  ): void {

    let texto_modificado = this.proyecto.text;
  
    // Reemplazar saltos de línea para manejar el formato correctamente
    texto_modificado = texto_modificado.replace(/\n/g, `<br>`);
  
    palabras.forEach(palabra => {
      const posiciones = posicionesPorPalabra[palabra] || [];
  
      if (posiciones.length === 0) {
        console.warn(`No hay posiciones almacenadas para la palabra "${palabra}".`);
        return;
      }
  
      // Revisar si hay otras variaciones de esa palabra con distinta capitalización en la misma categoría
      const palabrasCategoria = Object.keys(posicionesPorPalabra).filter(p =>
        posicionesPorPalabra[p].some(pos => pos.categoria === categoria)
      );
  
      const palabraLower = palabra.toLowerCase();
      const tieneVariaciones = palabrasCategoria.some(p => p.toLowerCase() === palabraLower && p !== palabra);
  
      const flags = tieneVariaciones ? 'g' : 'gi';
      let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, flags);
  

  
      if (coincidenciasEncontradas.length === 0) {
        console.error(`No se encontraron instancias de "${palabra}" en el texto.`);
        return;
      }
  
      let posicionesValidas = posiciones.map(p => p.posicion).sort((a, b) => a - b);
      let textoFinal = texto_modificado;
      let desplazamiento = 0;
  
      posicionesValidas.forEach((posicionSeleccionada, index) => {
        if (index >= coincidenciasEncontradas.length) return;
  
        let coincidenciaSeleccionada = coincidenciasEncontradas[index];
        let palabraOriginal = coincidenciaSeleccionada[0];
        let inicio = coincidenciaSeleccionada.index! + desplazamiento;
        let fin = inicio + palabraOriginal.length;
  
        const categoriaCorrecta = posiciones.some(p => p.posicion === posicionSeleccionada && p.categoria === categoria);
  
        if (categoriaCorrecta) {
          let categoriaFinal = categoria;

           if ("???" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extra";
             }
           if ("," === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraS";
             }
             if (":" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraT";
             }
              if ("$" === categoriaFinal.toUpperCase()) {
               categoriaFinal = "extraF";
             }


          const categoriaUpper = categoriaFinal.toUpperCase();
          let tagCategoria = categoriaUpper === 'PP$' ? 'PP2' : categoriaUpper;
          let palabraResaltada = `<ttg-${tagCategoria}>${palabraOriginal}</ttg-${tagCategoria}>`;
  
          textoFinal =
            textoFinal.substring(0, inicio) +
            palabraResaltada +
            textoFinal.substring(fin);
  
          desplazamiento += palabraResaltada.length - palabraOriginal.length;
        }
      });
  
      texto_modificado = textoFinal;
    });
  
  
    // Aplicar cambios en la interfaz
    this.proyecto.texto_modificado = texto_modificado;
    this.showHighlightedContent(texto_modificado, { editable: false });
    this.messageValue.next(true);
    this.valueCopy.next(false);
  }
  

  public resaltarMultiplesCoincidenciasMeta(
    palabras: string[],
    categoria: string,
    posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] },
    etiquetasMap: { [key: string]: string },
    http
  ): void {
    let texto_modificado = this.proyecto.text;
    texto_modificado = texto_modificado.replace(/\n/g, `<br>`);
  
    palabras.forEach(palabra => {
      const posiciones = posicionesPorPalabra[palabra] || [];
  
      if (posiciones.length === 0) return;
      // Regex que permite apóstrofes, guiones, etc. en medio de la palabra
      // Detectar si hay variaciones de la palabra con distinta capitalización en la misma categoría
    const palabrasCategoria = Object.keys(posicionesPorPalabra).filter(p =>
      posicionesPorPalabra[p].some(pos => pos.categoria === categoria)
    );

    const palabraLower = palabra.toLowerCase();
    const tieneVariaciones = palabrasCategoria.some(p => p.toLowerCase() === palabraLower && p !== palabra);

    // Regex con o sin sensibilidad de mayúsculas/minúsculas
    const flags = tieneVariaciones ? 'g' : 'gi';
    let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, flags);
  
      if (coincidenciasEncontradas.length === 0) return;
  
      let posicionesValidas = posiciones.map(p => p.posicion).sort((a, b) => a - b);
      let textoFinal = texto_modificado;
      let desplazamiento = 0;
  
      posicionesValidas.forEach((posicionSeleccionada, index) => {
        if (index >= coincidenciasEncontradas.length) return;
  
        let coincidenciaSeleccionada = coincidenciasEncontradas[index];
        let palabraOriginal = coincidenciaSeleccionada[0];
        let inicio = coincidenciaSeleccionada.index! + desplazamiento;
        let fin = inicio + palabraOriginal.length;
  
        const categoriaCorrecta = posiciones.some(p => p.posicion === posicionSeleccionada && p.categoria === categoria);
  
        if (categoriaCorrecta) {
          const etiqueta = etiquetasMap[categoria] || categoria;
          let palabraResaltada = `<ttg-${etiqueta}>${palabraOriginal}</ttg-${etiqueta}>`;
  
          textoFinal =
            textoFinal.substring(0, inicio) +
            palabraResaltada +
            textoFinal.substring(fin);
  
          desplazamiento += palabraResaltada.length - palabraOriginal.length;
        }
      });
  
      texto_modificado = textoFinal;
    });
  
    this.proyecto.texto_modificado = texto_modificado;
    this.showHighlightedContent(texto_modificado, { editable: true });
    this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
  // this.messageValue.next(true);
    this.valueCopy.next(false);
  }
  

  aplicarResaltado(posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] },http): void {
    let texto_modificado = this.proyecto.text.replace(/\n/g, `<br>`);

    Object.keys(posicionesPorPalabra).forEach(palabra => {
        const posiciones = posicionesPorPalabra[palabra] || [];

        if (posiciones.length === 0) return;

        const categoria = posiciones[0].categoria;
        const palabrasCategoria = Object.keys(posicionesPorPalabra).filter(p =>
          posicionesPorPalabra[p].some(pos => pos.categoria === categoria)
        );
  
        const palabraLower = palabra.toLowerCase();
        const tieneVariaciones = palabrasCategoria.some(p => p.toLowerCase() === palabraLower && p !== palabra);
  
        // Regex con o sin sensibilidad de mayúsculas/minúsculas
        const flags = tieneVariaciones ? 'g' : 'gi';
        let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, flags);

        let posicionesValidas = posiciones.map(p => p.posicion).sort((a, b) => a - b);
        let textoFinal = texto_modificado;
        let desplazamiento = 0;

        posicionesValidas.forEach((posicionSeleccionada, index) => {
            if (index >= coincidenciasEncontradas.length) return;

            let coincidenciaSeleccionada = coincidenciasEncontradas[index];
            let palabraOriginal = coincidenciaSeleccionada[0];
            let inicio = coincidenciaSeleccionada.index! + desplazamiento;
            let fin = inicio + palabraOriginal.length;

            const categoria = posiciones.find(p => p.posicion === posicionSeleccionada)?.categoria;

            if (categoria) {
                let palabraResaltada = `<ttg-${categoria}>${palabraOriginal}</ttg-${categoria}>`;

                textoFinal =
                    textoFinal.substring(0, inicio) +
                    palabraResaltada +
                    textoFinal.substring(fin);

                desplazamiento += palabraResaltada.length - palabraOriginal.length;
            }
        });

        texto_modificado = textoFinal;
    });

    this.proyecto.texto_modificado = texto_modificado;
    this.showHighlightedContent(texto_modificado);
    this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
    // this.messageValue.next(true);

    this.valueCopy.next(false);
}

aplicarResaltadoTagger(
  posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] },
  http
): void {
  let texto_modificado = this.proyecto.text.replace(/\n/g, `<br>`);
  const categoriasMasUsadas: { [original: string]: string } = {};
  let contadorMas = 1;

  const palabrasCategoria = Object.keys(posicionesPorPalabra);
  let palabrasTexto = texto_modificado.split(/\b/);
  let palabrasMarcadas: string[] = [];

  let posicionActual = 0;

  palabrasTexto.forEach((palabraTextoOriginal, index) => {
    const palabraTexto = palabraTextoOriginal.trim();
    const palabraTextoLower = palabraTexto.toLowerCase();

    // Buscar coincidencias considerando variaciones con comillas, tildes, etc.
    const coincidencias = palabrasCategoria.filter(p => {
      const palabraLower = p.toLowerCase();
      const tieneVariaciones = palabrasCategoria.some(px => px.toLowerCase() === palabraLower && px !== p);
      const flags = tieneVariaciones ? 'g' : 'gi';
      return this.getWordMatches(palabraTexto, p, flags).length > 0;
    });

    if (coincidencias.length > 0) {
      let palabraElegida = coincidencias[0];
      const posiciones = posicionesPorPalabra[palabraElegida];
      const posData = posiciones.find(p => p.posicion === posicionActual);

      if (posData) {
        let categoria = posData.categoria;

        if (categoria.toUpperCase() === "???") categoria = "extra";
        if (categoria === ",") categoria = "extraS";
        if (categoria === ":") categoria = "extraT";
        if (categoria === "$") categoria = "extraF";

        const categoriaUpper = categoria.toUpperCase();

        if (["IN", "TO", "THAT", "STOP"].includes(categoriaUpper)) {
          if (!categoriasMasUsadas[categoriaUpper]) {
            categoriasMasUsadas[categoriaUpper] = `mas${contadorMas > 1 ? contadorMas : ""}`;
            contadorMas++;
          }
          categoria = categoriasMasUsadas[categoriaUpper];
        }

        const tagCategoria = categoriaUpper === "PP$" ? "PP2" : categoriaUpper;
        const palabraResaltada = `<ttg-${tagCategoria}>${palabraTextoOriginal}</ttg-${tagCategoria}>`;

        palabrasMarcadas.push(palabraResaltada);
        posicionActual++;
        return;
      }
    }

    palabrasMarcadas.push(palabraTextoOriginal);

    if (palabraTexto.match(/\w/)) {
      posicionActual++;
    }
  });

  texto_modificado = palabrasMarcadas.join('');
  this.proyecto.texto_modificado = texto_modificado;
  this.showHighlightedContent(texto_modificado);
  this.blurHandler = () => this.terminarEdicionErrores(http);
  document.getElementById('highlighted-content')!.addEventListener('focus', () => {
    this.tuvoFocus = true;
  });

  document.getElementById('highlighted-content')!.addEventListener('input', () => {
    const original = this.proyecto.text;
    const actual = document.getElementById('highlighted-content')!.innerText.trim();
    this.showEditEye(actual !== original.trim());
  });

  this.valueCopy.next(false);
}




aplicarResaltadoTaggerFree(posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] }): void {
  let texto_modificado = this.proyecto.text.replace(/\n/g, `<br>`);
  // Llevar el control de las categorías "mas" usadas
  const categoriasMasUsadas: { [original: string]: string } = {};
  let contadorMas = 1;
  Object.keys(posicionesPorPalabra).forEach(palabra => {

      const posiciones = posicionesPorPalabra[palabra] || [];

      if (posiciones.length === 0) return;

      const categoria = posiciones[0].categoria;
      const palabrasCategoria = Object.keys(posicionesPorPalabra).filter(p =>
        posicionesPorPalabra[p].some(pos => pos.categoria === categoria)
      );

      const palabraLower = palabra.toLowerCase();
      const tieneVariaciones = palabrasCategoria.some(p => p.toLowerCase() === palabraLower && p !== palabra);

      // Regex con o sin sensibilidad de mayúsculas/minúsculas
      const flags = tieneVariaciones ? 'g' : 'gi';
      let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, flags);

      let posicionesValidas = posiciones.map(p => p.posicion).sort((a, b) => a - b);
      let textoFinal = texto_modificado;
      let desplazamiento = 0;

      posicionesValidas.forEach((posicionSeleccionada, index) => {
          if (index >= coincidenciasEncontradas.length) return;

          let coincidenciaSeleccionada = coincidenciasEncontradas[index];
          let palabraOriginal = coincidenciaSeleccionada[0];
          let inicio = coincidenciaSeleccionada.index! + desplazamiento;
          let fin = inicio + palabraOriginal.length;

          const categoria = posiciones.find(p => p.posicion === posicionSeleccionada)?.categoria;

          if (categoria) {
            let categoriaFinal = categoria;
           if ("???" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extra";
             }
           if ("," === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraS";
             }
             if (":" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraT";
             }
              if ("$" === categoriaFinal.toUpperCase()) {
               categoriaFinal = "extraF";
             }
            if (["IN", "TO", "THAT", "STOP"].includes(categoriaFinal.toUpperCase())) {
              if (!categoriasMasUsadas[categoriaFinal.toUpperCase()]) {
                categoriasMasUsadas[categoriaFinal.toUpperCase()] = `mas${contadorMas > 1 ? contadorMas : ""}`;
                contadorMas++;
              }

              categoriaFinal = categoriasMasUsadas[categoriaFinal.toUpperCase()];
            }
              const categoriaUpper = categoriaFinal.toUpperCase();
              let tagCategoria = categoriaUpper === 'PP$' ? 'PP2' : categoriaUpper;
              let palabraResaltada = `<ttg-${tagCategoria}>${palabraOriginal}</ttg-${tagCategoria}>`;

              textoFinal =
                  textoFinal.substring(0, inicio) +
                  palabraResaltada +
                  textoFinal.substring(fin);

              desplazamiento += palabraResaltada.length - palabraOriginal.length;
          }
      });

      texto_modificado = textoFinal;
  });

  this.proyecto.texto_modificado = texto_modificado;
  this.showHighlightedContent(texto_modificado, { editable: false });
  this.messageValue.next(true);
  this.valueCopy.next(false);
}
  
public resaltarMultiplesCoincidenciasCategoriaTagger(
  palabras: string[],
  categoria: string,
  posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[]},
  http
): void {
  let texto_modificado = this.proyecto.text.replace(/\n/g, `<br>`);

  palabras.forEach(palabra => {

      const posiciones = posicionesPorPalabra[palabra] || [];


      if (posiciones.length === 0) {
          console.warn(`No hay posiciones almacenadas para la palabra "${palabra}".`);
          return;
      }

      // Tomamos solo la categoría de esta palabra en este ciclo, no compartida
      const categoriasDeLaPalabra = posiciones.map(p => p.categoria);
      const categoriaActual = categoriasDeLaPalabra[0];  // Usamos directamente la del primer elemento

      // Solo buscar si existen otras palabras distintas (con diferente casing) con la misma categoría
      const palabrasCategoria = Object.keys(posicionesPorPalabra).filter(p =>
        p.toLowerCase() !== palabra.toLowerCase() &&
        posicionesPorPalabra[p].some(pos => pos.categoria === categoriaActual)
      );

      const tieneVariaciones = palabrasCategoria.length > 0;



      // Regex con o sin sensibilidad de mayúsculas/minúsculas
      const escapedWord = palabra.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const flags = tieneVariaciones ? 'g' : 'gi';
      let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, flags);

      if (coincidenciasEncontradas.length === 0) {
          console.error(`No se encontraron instancias de "${palabra}" en el texto.`);
          return;
      }

      let posicionesValidas = posiciones.map(p => p.posicion).sort((a, b) => a - b);
      let textoFinal = texto_modificado;
      let desplazamiento = 0;

      posicionesValidas.forEach((posicionSeleccionada, index) => {
          if (index >= coincidenciasEncontradas.length) return;

          let coincidenciaSeleccionada = coincidenciasEncontradas[index];
          let palabraOriginal = coincidenciaSeleccionada[0];
          let inicio = coincidenciaSeleccionada.index! + desplazamiento;
          let fin = inicio + palabraOriginal.length;

          const categoriaCorrecta = posiciones.some(p => p.posicion === posicionSeleccionada && p.categoria === categoria);

          if (categoriaCorrecta) {
            let categoriaFinal = categoria;
 
            if ("IN" === categoriaFinal.toUpperCase() || "TO" === categoriaFinal.toUpperCase() || "THAT" === categoriaFinal.toUpperCase() || "STOP" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "mas";
             }

              if ("???" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extra";
             }
           if ("," === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraS";
             }
             if (":" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraT";
             }
              if ("$" === categoriaFinal.toUpperCase()) {
               categoriaFinal = "extraF";
             }

              const categoriaUpper = categoriaFinal.toUpperCase();
              let tagCategoria = categoriaUpper === 'PP$' ? 'PP2' : categoriaUpper;
              let palabraResaltada = `<ttg-${tagCategoria}>${palabraOriginal}</ttg-${tagCategoria}>`;

              textoFinal =
                  textoFinal.substring(0, inicio) +
                  palabraResaltada +
                  textoFinal.substring(fin);

              desplazamiento += palabraResaltada.length - palabraOriginal.length;
          }
      });

      texto_modificado = textoFinal;
  });


  this.proyecto.texto_modificado = texto_modificado;
  this.showHighlightedContent(texto_modificado);
    this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
  // this.messageValue.next(true);
  this.valueCopy.next(false);
}

public resaltarMultiplesCoincidenciasCategoriaTaggerFree(
  palabras: string[],
  categoria: string,
  posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[]}
): void {
  let texto_modificado = this.proyecto.text.replace(/\n/g, `<br>`);

  palabras.forEach(palabra => {

      const posiciones = posicionesPorPalabra[palabra] || [];


      if (posiciones.length === 0) {
          console.warn(`No hay posiciones almacenadas para la palabra "${palabra}".`);
          return;
      }

      const categoria = posiciones[0].categoria;
      const palabrasCategoria = Object.keys(posicionesPorPalabra).filter(p =>
        posicionesPorPalabra[p].some(pos => pos.categoria === categoria)
      );

      const palabraLower = palabra.toLowerCase();
      const tieneVariaciones = palabrasCategoria.some(p => p.toLowerCase() === palabraLower && p !== palabra);

      // Regex con o sin sensibilidad de mayúsculas/minúsculas
      const escapedWord = palabra.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const flags = tieneVariaciones ? 'g' : 'gi';
      let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, flags);

      if (coincidenciasEncontradas.length === 0) {
          console.error(`No se encontraron instancias de "${palabra}" en el texto.`);
          return;
      }

      let posicionesValidas = posiciones.map(p => p.posicion).sort((a, b) => a - b);
      let textoFinal = texto_modificado;
      let desplazamiento = 0;

      posicionesValidas.forEach((posicionSeleccionada, index) => {
          if (index >= coincidenciasEncontradas.length) return;

          let coincidenciaSeleccionada = coincidenciasEncontradas[index];
          let palabraOriginal = coincidenciaSeleccionada[0];
          let inicio = coincidenciaSeleccionada.index! + desplazamiento;
          let fin = inicio + palabraOriginal.length;

          const categoriaCorrecta = posiciones.some(p => p.posicion === posicionSeleccionada && p.categoria === categoria);

          if (categoriaCorrecta) {
            let categoriaFinal = categoria;
 
            if ("IN" === categoriaFinal.toUpperCase() || "TO" === categoriaFinal.toUpperCase() || "THAT" === categoriaFinal.toUpperCase() || "STOP" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "mas";
             }

              if ("???" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extra";
             }
           if ("," === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraS";
             }
             if (":" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraT";
             }
              if ("$" === categoriaFinal.toUpperCase()) {
               categoriaFinal = "extraF";
             }


              const categoriaUpper = categoriaFinal.toUpperCase();
              let tagCategoria = categoriaUpper === 'PP$' ? 'PP2' : categoriaUpper;
              let palabraResaltada = `<ttg-${tagCategoria}>${palabraOriginal}</ttg-${tagCategoria}>`;

              textoFinal =
                  textoFinal.substring(0, inicio) +
                  palabraResaltada +
                  textoFinal.substring(fin);

              desplazamiento += palabraResaltada.length - palabraOriginal.length;
          }
      });

      texto_modificado = textoFinal;
  });


  this.proyecto.texto_modificado = texto_modificado;
  this.showHighlightedContent(texto_modificado, { editable: false });
  this.messageValue.next(true);
  this.valueCopy.next(false);
}

public resaltarMultiplesCoincidenciasCategoria(
  palabras: string[],
  categoria: string,
  posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] },
  http
): void {
  let texto_modificado = this.proyecto.text.replace(/\n/g, `<br>`);

  palabras.forEach(palabra => {
    
      const posiciones = posicionesPorPalabra[palabra] || [];


      if (posiciones.length === 0) {
          console.warn(`No hay posiciones almacenadas para la palabra "${palabra}".`);
          return;
      }

      let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, 'gi');

      if (coincidenciasEncontradas.length === 0) {
          console.error(`No se encontraron instancias de "${palabra}" en el texto.`);
          return;
      }

      let posicionesValidas = posiciones.map(p => p.posicion).sort((a, b) => a - b);
      let textoFinal = texto_modificado;
      let desplazamiento = 0;

      posicionesValidas.forEach((posicionSeleccionada, index) => {
          if (index >= coincidenciasEncontradas.length) return;

          let coincidenciaSeleccionada = coincidenciasEncontradas[index];
          let palabraOriginal = coincidenciaSeleccionada[0];
          let inicio = coincidenciaSeleccionada.index! + desplazamiento;
          let fin = inicio + palabraOriginal.length;

          const categoriaCorrecta = posiciones.some(p => p.posicion === posicionSeleccionada && p.categoria === categoria);

          if (categoriaCorrecta) {
              let palabraResaltada = `<ttg-${categoria}>${palabraOriginal}</ttg-${categoria}>`;

              textoFinal =
                  textoFinal.substring(0, inicio) +
                  palabraResaltada +
                  textoFinal.substring(fin);

              desplazamiento += palabraResaltada.length - palabraOriginal.length;
          }
      });

      texto_modificado = textoFinal;
  });


  this.proyecto.texto_modificado = texto_modificado;
  this.showHighlightedContent(texto_modificado, { editable: true });
  this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
  // this.messageValue.next(true);

  this.valueCopy.next(false);
}


public resaltarMultiplesCoincidenciasCategoriaMeta(
  palabras: string[],
  categoria: string,
  posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] ,},
  etiquetasMap: { [key: string]: string },
  http
): void {
  let texto_modificado = this.proyecto.text.replace(/\n/g, `<br>`);

  palabras.forEach(palabra => {
      const posiciones = posicionesPorPalabra[palabra] || [];


      if (posiciones.length === 0) {
          console.warn(`No hay posiciones almacenadas para la palabra "${palabra}".`);
          return;
      }

      let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, 'gi');

      if (coincidenciasEncontradas.length === 0) {
          console.error(`No se encontraron instancias de "${palabra}" en el texto.`);
          return;
      }

      let posicionesValidas = posiciones.map(p => p.posicion).sort((a, b) => a - b);
      let textoFinal = texto_modificado;
      let desplazamiento = 0;

      posicionesValidas.forEach((posicionSeleccionada, index) => {
          if (index >= coincidenciasEncontradas.length) return;

          let coincidenciaSeleccionada = coincidenciasEncontradas[index];
          let palabraOriginal = coincidenciaSeleccionada[0];
          let inicio = coincidenciaSeleccionada.index! + desplazamiento;
          let fin = inicio + palabraOriginal.length;

          const categoriaCorrecta = posiciones.some(p => p.posicion === posicionSeleccionada && p.categoria === categoria);

          if (categoriaCorrecta) {
              const etiqueta = etiquetasMap[categoria] || categoria;
              let palabraResaltada = `<ttg-${etiqueta}>${palabraOriginal}</ttg-${etiqueta}>`;

              textoFinal =
                  textoFinal.substring(0, inicio) +
                  palabraResaltada +
                  textoFinal.substring(fin);

              desplazamiento += palabraResaltada.length - palabraOriginal.length;
          }
      });

      texto_modificado = textoFinal;
  });


  this.proyecto.texto_modificado = texto_modificado;
  this.showHighlightedContent(texto_modificado, { editable: true });
  this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
  // this.messageValue.next(true);

  this.valueCopy.next(false);
}


aplicarResaltadoMeta(
  posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] },
  etiquetasMap: { [key: string]: string },
  http
): void {
  let texto_modificado = this.proyecto.text.replace(/\n/g, `<br>`);

  Object.keys(posicionesPorPalabra).forEach(palabra => {
      const posiciones = posicionesPorPalabra[palabra] || [];

      if (posiciones.length === 0) return;

      const categoria = posiciones[0].categoria;
      const palabrasCategoria = Object.keys(posicionesPorPalabra).filter(p =>
        posicionesPorPalabra[p].some(pos => pos.categoria === categoria)
      );

      const palabraLower = palabra.toLowerCase();
      const tieneVariaciones = palabrasCategoria.some(p => p.toLowerCase() === palabraLower && p !== palabra);

      // Regex con o sin sensibilidad de mayúsculas/minúsculas
      const escapedWord = palabra.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const flags = tieneVariaciones ? 'g' : 'gi';
      let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, flags);

      let posicionesValidas = posiciones.map(p => p.posicion).sort((a, b) => a - b);
      let textoFinal = texto_modificado;
      let desplazamiento = 0;

      posicionesValidas.forEach((posicionSeleccionada, index) => {
          if (index >= coincidenciasEncontradas.length) return;

          let coincidenciaSeleccionada = coincidenciasEncontradas[index];
          let palabraOriginal = coincidenciaSeleccionada[0];
          let inicio = coincidenciaSeleccionada.index! + desplazamiento;
          let fin = inicio + palabraOriginal.length;

          const categoria = posiciones.find(p => p.posicion === posicionSeleccionada)?.categoria;

          if (categoria) {
              const etiqueta = etiquetasMap[categoria] || categoria;
              let palabraResaltada = `<ttg-${etiqueta}>${palabraOriginal}</ttg-${etiqueta}>`;

              textoFinal =
                  textoFinal.substring(0, inicio) +
                  palabraResaltada +
                  textoFinal.substring(fin);

              desplazamiento += palabraResaltada.length - palabraOriginal.length;
          }
      });

      texto_modificado = textoFinal;
  });

  this.proyecto.texto_modificado = texto_modificado;
  this.showHighlightedContent(texto_modificado, { editable: true });
  this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
  // this.messageValue.next(true);
  this.valueCopy.next(false);
}


  public realizarMarcadoMultiple(objetoPalabras: Array<any>) {
    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);
    for (let index = 0; index < objetoPalabras.length; index++) {
      let palabras = objetoPalabras[index].words;
      let etiqueta = objetoPalabras[index].tag;
      for (let j = 0; j < palabras.length; j++) {
        const palabra = palabras[j];
        // Verificar si la palabra ya tiene una etiqueta <ttg-*>
        const regexEtiqueta = new RegExp(`(<ttg-[^>]+>\\b)${palabra}(\\b</ttg-[^>]+>)`, 'gi');
        if (regexEtiqueta.test(texto_modificado)) {
          continue; // Si la palabra ya tiene una etiqueta, no la volvemos a etiquetar
        }

        // -------------------------VERSION ORIGINAL----------------------------
        // Expresión regular para etiquetar solo si la palabra aún no está etiquetada
        // const regex = new RegExp(`(?<!<ttg-${etiqueta}>)\\b${palabra}\\b(?!</ttg-${etiqueta}>)`, 'gi');
        // Aplicar el etiquetado sin afectar palabras similares
        // texto_modificado = texto_modificado.replace(regex, (match) => {
        //   console.log(match)
        //   return `<ttg-${etiqueta}>${match}</ttg-${etiqueta}>`;
        // });

        // -------------------------------------------------------------------------
        const marcador = "__TEMP__";
        const etiquetas = [];
        texto_modificado = texto_modificado.replace(/<ttg-[^>]+>.*?<\/ttg-[^>]+>/gi, (match) => {
          etiquetas.push(match);
          return marcador;
        });

        // Paso 2: Hacer la sustitución solo en el contenido visible
        const regex = new RegExp(`\\b${palabra}\\b`, 'gi');
        texto_modificado = texto_modificado.replace(regex, `<ttg-${etiqueta}>${palabra}</ttg-${etiqueta}>`);

        // Paso 3: Restaurar el contenido de las etiquetas
        texto_modificado = texto_modificado.replace(new RegExp(marcador, 'g'), () => etiquetas.shift());
      }
    }
    
    this.proyecto.texto_modificado = texto_modificado;
    this.showHighlightedContent(texto_modificado);
    this.messageValue.next(true);
    this.valueCopy.next(false);
    
  }

  
public resaltarTodasLasCategorias(
  posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] },http
): void {
  let texto_modificado = this.proyecto.text.replace(/\n/g, `<br>`);

  Object.keys(posicionesPorPalabra).forEach(palabra => {
      const posiciones = posicionesPorPalabra[palabra] || [];


      if (posiciones.length === 0) {
          console.warn(`No hay posiciones almacenadas para la palabra "${palabra}".`);
          return;
      }

      const escapedWord = palabra.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, 'gi');

      if (coincidenciasEncontradas.length === 0) {
          console.error(`No se encontraron instancias de "${palabra}" en el texto.`);
          return;
      }

      let posicionesValidas = posiciones.map(p => p.posicion).sort((a, b) => a - b);
      let textoFinal = texto_modificado;
      let desplazamiento = 0;

      posicionesValidas.forEach((posicionSeleccionada, index) => {
          if (index >= coincidenciasEncontradas.length) return;

          let coincidenciaSeleccionada = coincidenciasEncontradas[index];
          let palabraOriginal = coincidenciaSeleccionada[0];
          let inicio = coincidenciaSeleccionada.index! + desplazamiento;
          let fin = inicio + palabraOriginal.length;

          const categoriaCorrecta = posiciones.some(p => p.posicion === posicionSeleccionada);

          if (categoriaCorrecta) {
              let palabraResaltada = `<ttg-${posiciones.find(p => p.posicion === posicionSeleccionada)!.categoria}>${palabraOriginal}</ttg-${posiciones.find(p => p.posicion === posicionSeleccionada)!.categoria}>`;

              textoFinal =
                  textoFinal.substring(0, inicio) +
                  palabraResaltada +
                  textoFinal.substring(fin);

              desplazamiento += palabraResaltada.length - palabraOriginal.length;
          }
      });

      texto_modificado = textoFinal;
  });


  this.proyecto.texto_modificado = texto_modificado;
  this.showHighlightedContent(texto_modificado, { editable: true });
  this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
  // this.messageValue.next(true);
  this.valueCopy.next(false);
}

public resaltarTodasLasCategoriasTagger(
  posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[], },http
): void {
  let texto_modificado = this.proyecto.text.replace(/\n/g, `<br>`);

  Object.keys(posicionesPorPalabra).forEach(palabra => {

      const posiciones = posicionesPorPalabra[palabra] || [];


      if (posiciones.length === 0) {
          console.warn(`No hay posiciones almacenadas para la palabra "${palabra}".`);
          return;
      }

      let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, 'g');

      if (coincidenciasEncontradas.length === 0) {
          console.error(`No se encontraron instancias de "${palabra}" en el texto.`);
          return;
      }

      let posicionesValidas = posiciones.map(p => p.posicion).sort((a, b) => a - b);
      let textoFinal = texto_modificado;
      let desplazamiento = 0;

      posicionesValidas.forEach((posicionSeleccionada, index) => {
          if (index >= coincidenciasEncontradas.length) return;

          let coincidenciaSeleccionada = coincidenciasEncontradas[index];
          let palabraOriginal = coincidenciaSeleccionada[0];
          let inicio = coincidenciaSeleccionada.index! + desplazamiento;
          let fin = inicio + palabraOriginal.length;

          const categoriaCorrecta = posiciones.some(p => p.posicion === posicionSeleccionada);

          if (categoriaCorrecta) {
            let categoriaFinal = posiciones.find(p => p.posicion === posicionSeleccionada)!.categoria;
            if ("IN" === categoriaFinal.toUpperCase() || "TO" === categoriaFinal.toUpperCase() || "THAT" === categoriaFinal.toUpperCase() || "STOP" === categoriaFinal.toUpperCase()) {
              categoriaFinal = "mas";
            }

             if ("???" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extra";
             }
           if ("," === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraS";
             }
             if (":" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraT";
             }
              if ("$" === categoriaFinal.toUpperCase()) {
               categoriaFinal = "extraF";
             }
          
            const categoriaUpper = categoriaFinal.toUpperCase();
            let tagCategoria = categoriaUpper === 'PP$' ? 'PP2' : categoriaUpper;
            let palabraResaltada = `<ttg-${tagCategoria}>${palabraOriginal}</ttg-${tagCategoria}>`;

              textoFinal =
                  textoFinal.substring(0, inicio) +
                  palabraResaltada +
                  textoFinal.substring(fin);

              desplazamiento += palabraResaltada.length - palabraOriginal.length;
          }
      });

      texto_modificado = textoFinal;
  });


  this.proyecto.texto_modificado = texto_modificado;
  this.showHighlightedContent(texto_modificado, { editable: true });
  this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
  // this.messageValue.next(true);
  this.valueCopy.next(false);
}

public resaltarTodasLasCategoriasTaggerFree(
  posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[], }
): void {
  let texto_modificado = this.proyecto.text.replace(/\n/g, `<br>`);

  Object.keys(posicionesPorPalabra).forEach(palabra => {

      const posiciones = posicionesPorPalabra[palabra] || [];


      if (posiciones.length === 0) {
          console.warn(`No hay posiciones almacenadas para la palabra "${palabra}".`);
          return;
      }

      let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, 'g');

      if (coincidenciasEncontradas.length === 0) {
          console.error(`No se encontraron instancias de "${palabra}" en el texto.`);
          return;
      }

      let posicionesValidas = posiciones.map(p => p.posicion).sort((a, b) => a - b);
      let textoFinal = texto_modificado;
      let desplazamiento = 0;

      posicionesValidas.forEach((posicionSeleccionada, index) => {
          if (index >= coincidenciasEncontradas.length) return;

          let coincidenciaSeleccionada = coincidenciasEncontradas[index];
          let palabraOriginal = coincidenciaSeleccionada[0];
          let inicio = coincidenciaSeleccionada.index! + desplazamiento;
          let fin = inicio + palabraOriginal.length;

          const categoriaCorrecta = posiciones.some(p => p.posicion === posicionSeleccionada);

          if (categoriaCorrecta) {
            let categoriaFinal = posiciones.find(p => p.posicion === posicionSeleccionada)!.categoria;
            if ("IN" === categoriaFinal.toUpperCase() || "TO" === categoriaFinal.toUpperCase() || "THAT" === categoriaFinal.toUpperCase() || "STOP" === categoriaFinal.toUpperCase()) {
              categoriaFinal = "mas";
            }

            
           if ("???" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extra";
             }
           if ("," === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraS";
             }
             if (":" === categoriaFinal.toUpperCase() ) {
               categoriaFinal = "extraT";
             }
              if ("$" === categoriaFinal.toUpperCase()) {
               categoriaFinal = "extraF";
             }
          
            const categoriaUpper = categoriaFinal.toUpperCase();
            let tagCategoria = categoriaUpper === 'PP$' ? 'PP2' : categoriaUpper;
            let palabraResaltada = `<ttg-${tagCategoria}>${palabraOriginal}</ttg-${tagCategoria}>`;

              textoFinal =
                  textoFinal.substring(0, inicio) +
                  palabraResaltada +
                  textoFinal.substring(fin);

              desplazamiento += palabraResaltada.length - palabraOriginal.length;
          }
      });

      texto_modificado = textoFinal;
  });


  this.proyecto.texto_modificado = texto_modificado;
  this.showHighlightedContent(texto_modificado, { editable: false });
  this.messageValue.next(true);
  this.valueCopy.next(false);
}

public resaltarTodasLasCategoriasMeta(
  posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] },
  etiquetasMap: { [key: string]: string },
  http
): void {
  let texto_modificado = this.proyecto.text.replace(/\n/g, `<br>`);

  Object.keys(posicionesPorPalabra).forEach(palabra => {
      const posiciones = posicionesPorPalabra[palabra] || [];


      if (posiciones.length === 0) {
          console.warn(`No hay posiciones almacenadas para la palabra "${palabra}".`);
          return;
      }

      const escapedWord = palabra.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      let coincidenciasEncontradas = this.getWordMatches(texto_modificado, palabra, 'gi');

      if (coincidenciasEncontradas.length === 0) {
          console.error(`No se encontraron instancias de "${palabra}" en el texto.`);
          return;
      }

      let posicionesValidas = posiciones.map(p => p.posicion).sort((a, b) => a - b);
      let textoFinal = texto_modificado;
      let desplazamiento = 0;

      posicionesValidas.forEach((posicionSeleccionada, index) => {
          if (index >= coincidenciasEncontradas.length) return;

          let coincidenciaSeleccionada = coincidenciasEncontradas[index];
          let palabraOriginal = coincidenciaSeleccionada[0];
          let inicio = coincidenciaSeleccionada.index! + desplazamiento;
          let fin = inicio + palabraOriginal.length;

          const categoriaCorrecta = posiciones.some(p => p.posicion === posicionSeleccionada);

          if (categoriaCorrecta) {
            const etiqueta = etiquetasMap[posiciones.find(p => p.posicion === posicionSeleccionada)!.categoria] || posiciones.find(p => p.posicion === posicionSeleccionada)!.categoria;
              let palabraResaltada = `<ttg-${etiqueta}>${palabraOriginal}</ttg-${etiqueta}>`;

              textoFinal =
                  textoFinal.substring(0, inicio) +
                  palabraResaltada +
                  textoFinal.substring(fin);

              desplazamiento += palabraResaltada.length - palabraOriginal.length;
          }
      });

      texto_modificado = textoFinal;
  });


  this.proyecto.texto_modificado = texto_modificado;
  this.showHighlightedContent(texto_modificado, { editable: true });
  this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
  // this.messageValue.next(true);
  this.valueCopy.next(false);
}


  public undoMarcadoMultiple(http){
    this.teardownPilotMirror();
    this.setHighlightDisplayMode();
    document.getElementById("Text-Area-Original").style.display = "";
    document.getElementById('highlighted-content')!.style.display = "none";
    document.getElementById('highlighted-content')!.innerHTML = "";
    document.getElementById('highlighted-content-specific')!.style.display = "none";
    document.getElementById('highlighted-content-specific')!.innerHTML = "";
    document.getElementById('highlighted-content')!.contentEditable = "false";
    document.getElementById('highlighted-content-specific')!.contentEditable = "false";
    this.updateEditEye(false);
    this.terminarEdicionErrores(http);
    this.showEditEye(false);
    this.messageValue.next(false);
    this.valueCopy.next(true);
    this.notifyTabChange();
  }

   public undoMarcadoMultiple2(){
    this.teardownPilotMirror();
    this.setHighlightDisplayMode();
    document.getElementById("Text-Area-Original").style.display = "";
    document.getElementById('highlighted-content')!.style.display = "none";
    document.getElementById('highlighted-content')!.innerHTML = "";
    document.getElementById('highlighted-content-specific')!.style.display = "none";
    document.getElementById('highlighted-content-specific')!.innerHTML = "";
    document.getElementById('highlighted-content')!.contentEditable = "false";
    document.getElementById('highlighted-content-specific')!.contentEditable = "false";
    this.updateEditEye(false);
    this.showEditEye(false);
    this.messageValue.next(false);
    this.valueCopy.next(true);
    this.notifyTabChange();
  }

  public undoMarcado(palabras:Array<String>, etiqueta:string){
    let texto_modificado = this.proyecto.texto_modificado
    // if (texto_modificado==''){
    // }
    // let texto_modificado = this.proyecto.text;
    // const salto = new RegExp(`(\n)`, 'gi');
    // texto_modificado = texto_modificado.replace(salto, `<br>`);
    for (let index = 0; index < palabras.length; index++) {
      let palabra = palabras[index];
      if (this.palabra_baneada(palabra)){
        texto_modificado = this.desmarcarSignoBaneado(texto_modificado, palabra, etiqueta);
      }else{
        //Ver como normalizar texto
        let regex = new RegExp(`<ttg-${etiqueta}>\\b${palabra}\\b</ttg-${etiqueta}>`, 'g');
        if (etiqueta == 'ge'){
          regex = new RegExp(`<ttg-${etiqueta}>(.*?)</ttg-${etiqueta}>`, 'g');
        }
        // console.log("vamos a buscar", regex);
        texto_modificado = texto_modificado.replace(regex, `${palabra}`);

      }
    }
    this.proyecto.texto_modificado = texto_modificado
    document.getElementById("Text-Area-Original").style.display = "";
    document.getElementById('highlighted-content')!.style.display = "none";
    document.getElementById('highlighted-content')!.innerHTML = "";
    document.getElementById('highlighted-content-specific')!.style.display = "none";
    document.getElementById('highlighted-content-specific')!.innerHTML = "";
    document.getElementById('highlighted-content')!.contentEditable = "false";
    document.getElementById('highlighted-content-specific')!.contentEditable = "false";
    this.updateEditEye(false);
    this.showEditEye(false);
    this.messageValue.next(false);
    this.valueCopy.next(true);
    this.notifyTabChange();
  }

  public undoMarcadoErrors(palabras:Array<String>, etiqueta:string,http){
    let texto_modificado = this.proyecto.texto_modificado
    // if (texto_modificado==''){
    // }
    // let texto_modificado = this.proyecto.text;
    // const salto = new RegExp(`(\n)`, 'gi');
    // texto_modificado = texto_modificado.replace(salto, `<br>`);
    for (let index = 0; index < palabras.length; index++) {
      let palabra = palabras[index];
      if (this.palabra_baneada(palabra)){
        texto_modificado = this.desmarcarSignoBaneado(texto_modificado, palabra, etiqueta);
      }else{
        //Ver como normalizar texto
        let regex = new RegExp(`<ttg-${etiqueta}>\\b${palabra}\\b</ttg-${etiqueta}>`, 'g');
        if (etiqueta == 'ge'){
          regex = new RegExp(`<ttg-${etiqueta}>(.*?)</ttg-${etiqueta}>`, 'g');
        }
        // console.log("vamos a buscar", regex);
        texto_modificado = texto_modificado.replace(regex, `${palabra}`);

      }
    }
    this.proyecto.texto_modificado = texto_modificado
    document.getElementById("Text-Area-Original").style.display = "";
    document.getElementById('highlighted-content')!.style.display = "none";
    document.getElementById('highlighted-content')!.innerHTML = "";
    document.getElementById('highlighted-content-specific')!.style.display = "none";
    document.getElementById('highlighted-content-specific')!.innerHTML = "";
    document.getElementById('highlighted-content')!.contentEditable = "false";
    document.getElementById('highlighted-content-specific')!.contentEditable = "false";
    // this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.removeEventListener('blur', this.blurHandler);
    this.updateEditEye(false);
    this.terminarEdicionErrores(http);
    this.showEditEye(false);
    this.tuvoFocus = false
    this.messageValue.next(false);
    this.valueCopy.next(true);
    this.notifyTabChange();
  }

  realizarMarcadoSentences(palabras: Array<string | { sentence: string }> = null, etiqueta: string = null): void {
    etiqueta = etiqueta.replaceAll(".", "-");

    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);

    for (let index = 0; index < palabras.length; index++) {
        let etiqueta_mod = `${etiqueta}${index % 2}`;
        let palabraObj = palabras[index];
        let palabra = typeof palabraObj === 'string' ? palabraObj : palabraObj.sentence;

        if (this.palabra_baneada(palabra)) {
            texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta_mod);
        } else {
            const escapedWord = palabra
              .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')  // escapar regex
              .replace(/ /g, "\\s*(?:<br>\\s*)?");     // permitir espacio o <br>
              
            // Regex con tolerancia
            const regex = this.regexLookbehindSupported
              ? new RegExp(`(?<!\\w)${escapedWord}(?!\\w)`, 'gi')
              : new RegExp(`(^|[^A-Za-z0-9_])(${escapedWord})(?![A-Za-z0-9_])`, 'gi');

            // Verificar si la palabra ya está dentro de una etiqueta
            const checkEtiqueta = new RegExp(`<ttg-.*?>${escapedWord}</ttg-.*?>`, 'gi');
            if (!checkEtiqueta.test(texto_modificado)) {
   
                texto_modificado = this.regexLookbehindSupported
                  ? texto_modificado.replace(regex, `<ttg-${etiqueta_mod}>${palabra}</ttg-${etiqueta_mod}>`)
                  : texto_modificado.replace(regex, `$1<ttg-${etiqueta_mod}>$2</ttg-${etiqueta_mod}>`);
            } else {

            }
        }
    }

    this.proyecto.texto_modificado = texto_modificado;
    this.showHighlightedContent(texto_modificado, { mode: 'summary' });
    this.messageValue.next(true);
    this.valueCopy.next(false);
}

realizarMarcadoSentencesSummary(palabras: Array<string | { sentence: string }> = null, etiqueta: string = null,http): void {
    etiqueta = etiqueta.replaceAll(".", "-");

    let texto_modificado = this.proyecto.text;
    const salto = new RegExp(`(\n)`, 'gi');
    texto_modificado = texto_modificado.replace(salto, `<br>`);

    for (let index = 0; index < palabras.length; index++) {
        let etiqueta_mod = `${etiqueta}${index % 2}`;
        let palabraObj = palabras[index];
        let palabra = typeof palabraObj === 'string' ? palabraObj : palabraObj.sentence;

        if (this.palabra_baneada(palabra)) {
            texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta_mod);
        } else {
            const escapedWord = palabra
              .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')  // escapar regex
              .replace(/ /g, "\\s*(?:<br>\\s*)?");     // permitir espacio o <br>
              
            // Regex con tolerancia
            const regex = this.regexLookbehindSupported
              ? new RegExp(`(?<!\\w)${escapedWord}(?!\\w)`, 'gi')
              : new RegExp(`(^|[^A-Za-z0-9_])(${escapedWord})(?![A-Za-z0-9_])`, 'gi');

            // Verificar si la palabra ya está dentro de una etiqueta
            const checkEtiqueta = new RegExp(`<ttg-.*?>${escapedWord}</ttg-.*?>`, 'gi');
            if (!checkEtiqueta.test(texto_modificado)) {
   
                texto_modificado = this.regexLookbehindSupported
                  ? texto_modificado.replace(regex, `<ttg-${etiqueta_mod}>${palabra}</ttg-${etiqueta_mod}>`)
                  : texto_modificado.replace(regex, `$1<ttg-${etiqueta_mod}>$2</ttg-${etiqueta_mod}>`);
            } else {

            }
        }
    }

    this.proyecto.texto_modificado = texto_modificado;
    // Mirror pilot paused. Keep the new path nearby for a quick rollback if needed.
    // this.showPilotMirrorHighlight(texto_modificado, { mode: 'summary', editable: true });
    this.showHighlightedContent(texto_modificado, { mode: 'summary' });
    this.valueCopy.next(false);
}


realizarMarcadoSentencesStatis(
  palabras: Array<string | { sentence: string }> = null,
  etiqueta: string = null,
  http,
  excludeDigits: boolean = false,
  highlightMode: 'default' | 'summary' = 'default'
): void {
  etiqueta = etiqueta.replaceAll(".", "-");

  if (!palabras || palabras.length === 0) {
    return;
  }

  let texto_modificado = this.proyecto.text;

  palabras.forEach((palabraObj, index) => {
    const palabra = typeof palabraObj === "string" ? palabraObj : palabraObj.sentence;
    const etiqueta_mod = `${etiqueta}${index % 2}`;

    if (!palabra) {
      return;
    }

    if (this.palabra_baneada(palabra)) {
      texto_modificado = this.marcarSignoBaneado(texto_modificado, palabra, etiqueta_mod);
      return;
    }

    const regex = this.buildFlexibleSentenceRegex(palabra, excludeDigits);

    texto_modificado = texto_modificado.replace(regex, (match) => {
      if (excludeDigits && !match.replace(/\d+/g, "").trim()) {
        return match;
      }

      return `<ttg-${etiqueta_mod}>${match}</ttg-${etiqueta_mod}>`;
    });
  });

  const salto = new RegExp(`(\n)`, "gi");
  texto_modificado = texto_modificado.replace(salto, `<br>`);


  this.proyecto.texto_modificado = texto_modificado;
  if (highlightMode === 'summary') {
    // Mirror pilot paused. Keep the new path nearby for a quick rollback if needed.
    // this.showPilotMirrorHighlight(texto_modificado, { mode: highlightMode, editable: true });
    this.showHighlightedContent(texto_modificado, { mode: highlightMode });
  } else {
    this.showHighlightedContent(texto_modificado, { mode: highlightMode });
  }
  this.updateEditEye(true);
  this.blurHandler = () => this.terminarEdicionErrores(http);

  document.getElementById("highlighted-content")!.addEventListener("focus", () => {
    this.tuvoFocus = true;
  });

  document.getElementById("highlighted-content")!.addEventListener("input", () => {
    const original = this.proyecto.text;
    const actual = document.getElementById("highlighted-content")!.innerText.trim();
    this.showEditEye(actual !== original.trim());
  });

  this.valueCopy.next(false);
}

private buildFlexibleSentenceRegex(sentence: string, allowIgnoredDigits: boolean = false): RegExp {
  const source = String(sentence).trim();
  let pattern = '';
  const ignoredDigitsPattern = allowIgnoredDigits
    ? '(?:[\\s.,:;/%$£€#()\\-–—]*\\d+[\\d\\s.,:;/%$£€#()\\-–—]*)*'
    : '';

  const appendPattern = (value: string): void => {
    pattern += `${value}${ignoredDigitsPattern}`;
  };

  pattern += ignoredDigitsPattern;

  for (let index = 0; index < source.length; index++) {
    const char = source[index];
    const nextChar = source[index + 1] || '';

    if (char === '\\' && /["“”'’´`]/.test(nextChar)) {
      continue;
    }

    if (/\s/.test(char)) {
      appendPattern('\\s+');
      continue;
    }

    if (/["“”]/.test(char)) {
      appendPattern('\\\\?["“”]?');
      continue;
    }

    if (/['’´`]/.test(char)) {
      appendPattern("\\\\?['’´`]?");
      continue;
    }

    if (char === '-') {
      appendPattern('[-–—]');
      continue;
    }

    appendPattern(char.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  }

  return new RegExp(pattern, 'g');
}




realizarMarcadoNumbers(): void {
  const paragraphs = this.proyecto.text.split(/\r?\n/);
  
  this.proyecto.texto_modificado = paragraphs.map(paragraph => {
    return paragraph.replace(/[^\d\s\/]*(\d+(?:\/\d+)?)[^\d\s\/]*/g, (match, number) => {
      if (number.includes('/')) {
        // Si el número contiene '/', marcar cada dígito individualmente
        return number.split('').map(char => char === '/' ? '/' : `<ttg-number>${char}</ttg-number>`).join('');
      }
      // Marcar solo el número, ignorando cualquier símbolo alrededor
      return `<ttg-number>${number}</ttg-number>`;
    });
  }).join('\n');

  this.showHighlightedContent(this.proyecto.texto_modificado, { editable: false });
  
  this.messageValue.next(true);
  this.valueCopy.next(false);
}

realizarMarcadoNumbersStatis(http): void {
  const paragraphs = this.proyecto.text.split(/\r?\n/);
  
  this.proyecto.texto_modificado = paragraphs.map(paragraph => {
    return paragraph.replace(/[^\d\s\/]*(\d+(?:\/\d+)?)[^\d\s\/]*/g, (match, number) => {
      if (number.includes('/')) {
        // Si el número contiene '/', marcar cada dígito individualmente
        return number.split('').map(char => char === '/' ? '/' : `<ttg-number>${char}</ttg-number>`).join('');
      }
      // Marcar solo el número, ignorando cualquier símbolo alrededor
      return `<ttg-number>${number}</ttg-number>`;
    });
  }).join('\n');

  this.showHighlightedContent(this.proyecto.texto_modificado);
    this.blurHandler = () => this.terminarEdicionErrores(http);
    document.getElementById('highlighted-content')!.addEventListener('focus', ()=>{
      this.tuvoFocus=true
    });

     document.getElementById('highlighted-content')!.addEventListener('input', () => {
      const original = this.proyecto.text;
      const actual = document.getElementById('highlighted-content')!.innerText.trim();
      this.showEditEye(actual !== original.trim());
    });
    // document.getElementById('highlighted-content')!.addEventListener('blur', this.blurHandler);
  this.valueCopy.next(false);
}


listaDeNumeros: string[] = []; // aquí guardaremos los números

listaNumbersStatis(): string[] {
  const listaDeNumeros: string[] = []; // local aquí
  const paragraphs = this.proyecto.text.split(/\r?\n/);

  this.proyecto.texto_modificado = paragraphs.map(paragraph => {
    return paragraph.replace(/[^\d\s\/]*(\d+(?:\/\d+)?)[^\d\s\/]*/g, (match, number) => {
      listaDeNumeros.push(number); // guardamos el número
      return `[${number}]`; // opcional: texto modificado
    });
  }).join('\n');

  return listaDeNumeros; // devolvemos la lista
}
  
  
  
  
  undoMarcadoSentences(): void {
    this.teardownPilotMirror();
    // Restaurar el texto original
    const textAreaOriginal = document.getElementById('Text-Area-Original');
    const highlightedContent = document.getElementById('highlighted-content');
  
    if (textAreaOriginal && highlightedContent) {
      textAreaOriginal.style.display = '';
      highlightedContent.style.display = 'none';
      highlightedContent.innerHTML = '';
    }
    this.messageValue.next(false);
    this.valueCopy.next(true);
  }

  undoMarcadoSentencesStatis(http): void {
    this.teardownPilotMirror();
    // Restaurar el texto original
    const textAreaOriginal = document.getElementById('Text-Area-Original');
    const highlightedContent = document.getElementById('highlighted-content');
  
    if (textAreaOriginal && highlightedContent) {
      textAreaOriginal.style.display = '';
      highlightedContent.style.display = 'none';
      highlightedContent.innerHTML = '';
    }
    document.getElementById("Text-Area-Original").style.display = "";
    document.getElementById('highlighted-content')!.style.display = "none";
    document.getElementById('highlighted-content')!.innerHTML = "";
    document.getElementById('highlighted-content-specific')!.style.display = "none";
    document.getElementById('highlighted-content-specific')!.innerHTML = "";
    document.getElementById('highlighted-content')!.contentEditable = "false";
    document.getElementById('highlighted-content-specific')!.contentEditable = "false";
     this.updateEditEye(false);
    this.terminarEdicionErrores(http);
    this.showEditEye(false);
    
    this.messageValue.next(false);
    this.valueCopy.next(true);
    this.notifyTabChange();
  }
  
  
  

  public async getinfo(http, id_project){
    let response = await this.fachada.getInfoProyect(http, id_project)
    this.limpiarPestañasStorage();
    // console.log("httt"+http+"idpro"+id_project+"cookies"+user_cookie)
    // console.log("RESPONSE"+response);
    this.proyecto = response;
    this.proyecto.texto_modificado = '';
    this.saveProjectIdToSessionStorage(this.proyecto.id_project, this.proyecto.text_UID);
    this.firstProject = true;
    this.dataSubject.next({ proyecto: this.proyecto, firstProject: this.firstProject }); // Notifica a todos los suscriptores
  }

  public async updateData(new_project){
    this.limpiarPestañasStorage();
    this.proyecto = new_project;
    this.proyecto.texto_modificado = '';
    this.saveProjectIdToSessionStorage(this.proyecto.id_project, this.proyecto.text_UID);
    this.verifyLoaderAnalyzing(false)
    this.firstProject = false;
    this.dataSubject.next({ proyecto: this.proyecto, firstProject: this.firstProject }); // Notifica a todos los suscriptores
  }

  public clearProjectData(){
    this.proyecto = { 
      id_project:'',
      user:{},
      name:'',
      config_json:{
        "delimiter": "%23",
        "split": "1",
        "textmode": "Writing",
        "englishType": "british",
        "targetCEFR": "A1",
        "matchPrhases": false
      },
      text:'Welcome to Text Inspector! To start, please replace this text here with the text you wish to inspect. You can either copy and paste your text here or import your text from a .txt or .doc file.\n \nAs you add text here, result will be shown on the right. ➔' ,
      texto_modificado:'',
      text_UID:'',
      sections:'',
      creation: "2024-10-08T09:27:22.792149Z",
      wordlist: null,
      update:null
    }
    
  }


  private marcarSignoBaneado(texto: string, palabra: any, etiqueta: string): string {
    if (!this.palabra_baneada(palabra)) {
      return texto;
    }

    const signo = String(palabra);
    const pattern = signo === "'" ? "['’´`]" : signo === '"' ? '["“”]' : signo.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(pattern, 'g');

    return texto
      .split(/(<[^>]+>)/g)
      .map(segmento => {
        if (segmento.startsWith('<') && segmento.endsWith('>')) {
          return segmento;
        }

        return segmento.replace(regex, `<ttg-${etiqueta}>$&</ttg-${etiqueta}>`);
      })
      .join('');
  }

  private desmarcarSignoBaneado(texto: string, palabra: any, etiqueta: string): string {
    if (!this.palabra_baneada(palabra)) {
      return texto;
    }

    const signo = String(palabra);
    const pattern = signo === "'" ? "['’´`]" : signo === '"' ? '["“”]' : signo.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`<ttg-${etiqueta}>(${pattern})<\\/ttg-${etiqueta}>`, 'g');

    return texto.replace(regex, '$1');
  }

  private supportsRegexLookbehind(): boolean {
    try {
      new RegExp('(?<!a)b');
      return true;
    } catch {
      return false;
    }
  }

  private buildWordPattern(palabra: any): string {
    return String(palabra)
      .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      .replace(/['’´-]/g, "['’´-]?");
  }

  private getWordMatches(texto: string, palabra: any, flags: string = 'gi'): Array<{ text: string; index: number; 0: string }> {
    const safeFlags = flags.includes('g') ? flags : `${flags}g`;
    const pattern = this.buildWordPattern(palabra);
    const regex = this.regexLookbehindSupported
      ? new RegExp(`(?<!\\w)${pattern}(?!\\w)`, safeFlags)
      : new RegExp(`(^|[^A-Za-z0-9_])(${pattern})(?![A-Za-z0-9_])`, safeFlags);

    return [...texto.matchAll(regex)].map(match => {
      if (this.regexLookbehindSupported) {
        return { 0: match[0], text: match[0], index: match.index! };
      }

      const prefix = match[1] ?? '';
      const word = match[2] ?? '';
      return { 0: word, text: word, index: match.index! + prefix.length };
    });
  }

  private marcarPalabraFueraDeTags(texto: string, palabra: any, etiqueta: string, flags: string = 'gi'): string {
    const safeFlags = flags.includes('g') ? flags : `${flags}g`;
    const pattern = this.buildWordPattern(palabra);
    const regex = this.regexLookbehindSupported
      ? new RegExp(`(?<!\\w)${pattern}(?!\\w)`, safeFlags)
      : new RegExp(`(^|[^A-Za-z0-9_])(${pattern})(?![A-Za-z0-9_])`, safeFlags);
    let insideTtg = false;

    return texto
      .split(/(<[^>]+>)/g)
      .map(segmento => {
        if (segmento.startsWith('<') && segmento.endsWith('>')) {
          if (/^<ttg-[^>]+>/i.test(segmento)) {
            insideTtg = true;
          } else if (/^<\/ttg-[^>]+>/i.test(segmento)) {
            insideTtg = false;
          }
          return segmento;
        }

        if (insideTtg) {
          return segmento;
        }

        return this.regexLookbehindSupported
          ? segmento.replace(regex, `<ttg-${etiqueta}>$&</ttg-${etiqueta}>`)
          : segmento.replace(regex, `$1<ttg-${etiqueta}>$2</ttg-${etiqueta}>`);
      })
      .join('');
  }

  palabra_baneada(palabra){
    const no_good=["'","\"",".","[","]",",","-"]
    for (let index = 0; index < no_good.length; index++) {
      const element = no_good[index];
      if (element ==palabra){
        return true;
      }
    }
    return false
  }


  async setDeleteProyect(http: any, value: boolean, projectId: number, textUID: string) { 
  // Guardamos los valores actuales del sessionStorage
  const storedId = sessionStorage.getItem("id_project");
  const storedTextUID = sessionStorage.getItem("text_UID");

  const projectRaw = sessionStorage.getItem("analysis_op");

  if (projectRaw) {
    try {
      const project = JSON.parse(projectRaw);
       if (project.related_projects && Array.isArray(project.related_projects)) {
        const match = project.related_projects.some(p => 
         p.id_project === projectId && p.text_UID === textUID
        );
        if (match) {
            // Revisar si existe related_projects y es array
            if (project.related_projects && Array.isArray(project.related_projects)) {
              const match2 = project.related_projects.some(p => 
                p.id_project.toString() === storedId && p.text_UID === storedTextUID
              );

              if (match2) {
                // Si coincide, eliminar del sessionStorage
                sessionStorage.removeItem("id_project");
                sessionStorage.removeItem("text_UID");
                sessionStorage.removeItem('analysis_op');
                this.limpiarPestañasStorage();
              }
            }}
          } }catch (error) {
            console.error("Error al parsear analysis_op:", error);
          }
  }

  this.deleteProyect = value; 
  const data = { id_project: projectId, textuid: textUID };
  console.log(`Delete: ${this.deleteProyect}, Project ID: ${projectId}, TextUID: ${textUID}`); 

  await this.fachada.deleteProject(http, data);
}


  private refreshTextBoxSubject = new Subject<void>();
  get refreshTextBox$() { 
    return this.refreshTextBoxSubject.asObservable(); 
  } 

  triggerTextBoxRefresh() { 
    this.refreshTextBoxSubject.next(); 
  }

  private refreshAnalyseSubject = new Subject<void>();
  get refreshAnalyse$() { 
    return this.refreshAnalyseSubject.asObservable(); 
  } 

  triggerAnalyseRefresh() { 
    this.refreshAnalyseSubject.next(); 
  }

  cleanEyes(){
    const eyeIcon = document.querySelectorAll('img[src*="eye-on-icon.svg"]')
    eyeIcon.forEach((icon) =>{
      (icon as HTMLImageElement).src = './assets/images/eye-icon.svg';
    });
  }



  private tabChangedSource = new Subject<void>();
  tabChanged$ = this.tabChangedSource.asObservable();

  notifyTabChange() {
    this.tabChangedSource.next();
  }

  limpiarHTMLPersonalizado(html) {
    if (!html) return '';

    const normalizedHtml = html
      .replace(/&nbsp;/gi, ' ')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/(div|p|li|section|article|blockquote|h[1-6])>/gi, '\n')
      .replace(/<(div|p|li|section|article|blockquote|h[1-6])(\s[^>]*)?>/gi, '')
      .replace(/<\/?ttg-[^>]+>/g, '');

    const temp = document.createElement('div');
    temp.innerHTML = normalizedHtml;

    return (temp.textContent || temp.innerText || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\r/g, '')
      .replace(/[ \t]+\n/g, '\n')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }
}
